import React from 'react'
import {withStyles} from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';


import Alert from '@mui/material/Alert';
import { Collapse } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { NumericFormat as NumberFormat } from 'react-number-format';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl'; 
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PresenterVersions from './PresenterVersions'
import OrderAgreement from './OrderAgreement'
import PresentationViewer from './PresentationViewer'


import {getSolarSavigsFromServer, getFinanceRates, GetMaintenanceOptions, APIGetJSONMappings, APIImageMerge, GetPanels, GetBatterys, APIGetDirections, APIFixedCosts, APIAncillaryCosts, APIMountingHardwareMap, APIProductSuppliersForType, APIPricingConfig, APIOutputPricing, APIloggedin, APIAddAgreementVersion, APIGetAgreementVersion, APIGetAgreementVersionForSite,  APIGetAllACControllers } from './Api'

import ErrorDialog from './ErrorDialog'
import CalcResultsSummaryTables from './CalcResultsSummaryTables'
import CalcResultsDetailsTables from './CalcResultsDetailsTables'
import SlideSetup from './SlideSetup'
import logo from './assets/images/mtsolarlog.png'
import pdf_config from './configs/pdf_configs'
import {Alerts3} from './Alerts'

import PictureUploads from './PictureUploads'
import LineChart from './LineChart'

import json_offer from './configs/offers.json'

//import pdf_pages from './pdf_field_mappings'
import  {PDFMergePage, PDFProcessDataTables } from './PDFMerge'
import {PDFPages} from './classes/PDFPages'
import {CalcInverters} from './CalcInverters'
// import { scryRenderedDOMComponentsWithClass } from 'react-dom/test-utils';
import ReactHtmlParser from 'react-html-parser';

import 'react-quill/dist/quill.snow.css';
// Redux
import { connect } from 'react-redux'
import {
    updatelistedproperty,
    updateconservationarea,
    updatedeposit,
    updaterepcustomermsg,
    updatesaveredux,
    updatecustomer2name,
    updatecustomer2surname,
    updatecustomer2title,
    updatecustomer2email,
    agreementcheckconfirmed,
    birdprotectionconfirmed,
    updatefinmonthlypayment,
    updatefintotalcost,
    updateagreementdata,
    updatempan,
    updatenoratedisclaimer,
    updateoffgridsystem,
    updatepropertytype,
    updateselectedsite
} from "./actions";

// New Redux slice selectors - single source of truth
import {
    selectElecConsumption, selectElecRate, selectSelectedTariff,
    selectSelfConsumption, selectGasConsumption, selectGasRate, selectGasEstimated
} from './store/slices/energySlice';
import {
    selectVoltageOptimiser, selectIBoost, selectSmartThermostat, selectBoilerManager,
    selectEVCharger, selectSoftGround, selectHardGround, selectDeliveryMiles,
    setDeliveryMiles, setSoftGround, setHardGround
} from './store/slices/addonsSlice';
import {
    selectBattery, selectPanelArrays, selectSavings, selectRequiredInverters,
    selectIs3Phase, selectOffgrid, selectACController, selectBatteryOnly
} from './store/slices/systemSlice';
import {
    selectSystemCost, selectNetCost, selectVat, selectHoldBasePrice, selectFinanceOption,
    selectFinanceTerm, selectFinanceCharge, selectCommPerc, selectCommSacrifice,
    selectAdditionalDiscount, selectSharedDiscount, selectSelectedMaintenance,
    selectAncillaryItems, selectOfferId, selectDontUpdateBase
} from './store/slices/financialSlice';
import {
    selectFlgId, selectCustomerName, selectCustomerFirstName, selectCustomerEmail,
    selectFullAddress, selectPostcode, selectRepName, selectRepEmail,
    selectSweepSale, selectAssignedRep, selectExtraOrderInfo, selectSelfGen
} from './store/slices/customerSlice';


var financeTerms = [{}]
var  json 
var pdf_pages = null
var hasOwnProperty = Object.prototype.hasOwnProperty;

var lineitems = []  // A list of items that make up the price
var checklist = []  // A list of items to check on pricing
var ancillarycosts = []
var fixedcosts = []
// Rail/clamp/hook slot -> ancillary ac_id mapping. Populated on mount from /api/mounting_hardware_map.
// Each entry: { _id, section: 'silver'|'black'|'hook', slot_type, colour, installation_id?, description, ac_id }
var mountingHardwareMap = []

// product_suppliers lookup, keyed by product_type → Map(product_id → best-priced supplier row).
// Populated on mount; used to flow real supplier prices into every BOM lineitem
// (panels / batterys / inverters / evchargers / ancillaries — fixedcosts is intentionally excluded).
const productSupplierMaps = {
    panels: new Map(),
    batterys: new Map(),
    inverters: new Map(),
    evchargers: new Map(),
    ancillaries: new Map()
}

// Pick the cheapest supplier row for a product following MT Solar's preference order:
//   1) cheapest active row that's IN STOCK (stock_status = 'STOCKS')
//   2) otherwise cheapest active row where the supplier holds stock for us ('HOLDS_STOCK')
//   3) otherwise cheapest active row regardless of stock_status (incl. DISCONTINUED).
const pickBestSupplierRow = (rows) => {
    if (!Array.isArray(rows) || rows.length === 0) return null
    const usable = rows.filter(r => r && r.active !== false && Number.isFinite(parseFloat(r.unit_cost)))
    if (usable.length === 0) return null
    const cheapest = (subset) => subset.reduce(
        (best, r) => parseFloat(r.unit_cost) < parseFloat(best.unit_cost) ? r : best
    )
    const tier1 = usable.filter(r => r.stock_status === 'STOCKS')
    if (tier1.length) return cheapest(tier1)
    const tier2 = usable.filter(r => r.stock_status === 'HOLDS_STOCK')
    if (tier2.length) return cheapest(tier2)
    return cheapest(usable)
}

// Resolve the supplier-priced unit cost for a product. Returns the supplier's
// `unit_cost` (ex-VAT) when we have a row for it, else the caller's fallback.
const supplierUnitCost = (productType, productId, fallback = 0) => {
    const map = productSupplierMaps[productType]
    if (!map) return fallback
    const row = map.get(productId)
    if (!row) return fallback
    const cost = parseFloat(row.unit_cost)
    return Number.isFinite(cost) ? cost : fallback
}

// pricing_config — admin-managed offer discounts, VAT rates, commission policy.
// Hydrated on mount; the calculator reads via `cfg(key, fallback)` so a missing
// row safely falls back to the legacy hard-coded value (typically a pdf_configs
// constant) and pricing keeps working.
const pricingConfig = new Map()
const cfg = (key, fallback) => {
    const row = pricingConfig.get(key)
    if (!row) return fallback
    const v = parseFloat(row.value)
    return Number.isFinite(v) ? v : fallback
}

// Proxy over the legacy pdf_config object: any access (`pdfc.priv_discount`,
// `pdfc.vat_rate`, etc.) first checks the live pricing_config Map, falling back
// to the original pdf_config value if no admin override exists. This lets us
// flip every site that read `pdf_config.X` to `pdfc.X` without surgically
// rewriting 30+ call sites — and any pdf_configs key not in pricing_config
// (e.g. dnos, years_per_page, template paths) still works exactly as before.
const pdfc = new Proxy(pdf_config, {
    get(target, prop) {
        if (typeof prop === 'string' && pricingConfig.has(prop)) {
            const row = pricingConfig.get(prop)
            const v = parseFloat(row.value)
            if (Number.isFinite(v)) return v
        }
        return target[prop]
    }
})


let vat_rate = pdfc.vat_rate  // Default to residential VAT Rate.

const SmallColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', 
    backgroundColor: '#04c659',
    '&:hover': {
      backgroundColor: '#04a659',
    },
    fontSize: '10px',
    paddingTop: '2px',
    paddingBottom: '2px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginLeft: '5px',
    marginRight: '5px'
  },
}))(Button);

const isEmpty = (obj) => {

    if (obj === null) return true;
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;
    if (typeof obj !== "object") return true;
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}

const ColorButton = withStyles((theme) => ({
    root: {
      color: '#ffffff', // theme.palette.getContrastText(lightGreen[50]),
      backgroundColor: '#04c659',
      '&:hover' : {
        backgroundColor: '#04d659',
      },
    },
}))(Button);

const console_log = (text) => { 
    return  // Comment out if yoy want logging
    console_log(text)
}
// Create our Tab Panels for Our Tabs.
// THese will hold the Details of each Panel Array
const  TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    let selval = 0
    if(!isNaN(value)) selval = value


    return (
      <Typography
      className={styles.tabpanel}
        component="div"
        role="tabpanel"
        hidden={selval !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {selval === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
}
  
// Prop Type for the TabPanels
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
// Get The Props for the Selected Tab - Index denotes the selected tab
const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

const NF = (props) => {
    const cur = props.cur
    return (
        <NumberFormat  value={props.value} 
        displayType={'text'} 
        thousandSeparator={true} 
        decimalSeparator={'.'}
        decimalScale={2}
        fixedDecimalScale={true}
        prefix={cur ? cur : ''}  />
    )
}

const SelectItems = (props) => {
    const lbl = 'lbl' + props.name
    let valid = 0
    let keyid = 0
    let readOnly = typeof props.readOnly !== "undefined" ? props.readOnly : false
    
    
    let err = false
    if(typeof props.error !== "undefined" && props.value == props.error)
                err = true
    return(
        <FormControl className={props.frmClass} error={err} >        
        <InputLabel id={lbl}>{props.title}</InputLabel>
        <Select
            labelid={lbl} 
            className={props.ctlClass}
            value={props.value}
            onChange={props.onChange} 
            readOnly = {readOnly}
            id= {props.name} name={props.name} 
            >
            {
                props.data.map((item) => { return ( <MenuItem key={props.dataKey === "genID" ? keyid++ : item[props.dataKey]} value={props.dataVal === "genID" ? valid++ : item[props.dataVal]} className={item[props.mnuClass]} >{item[props.dataDesc]} </MenuItem> )})
            }
        </Select> 
        </FormControl>       
    )
}

const createtable = (state) => {
    return (
        <CalcResultsDetailsTables state={state} />
    )
}

const Heading = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <Typography className={props.className} >{children}</Typography>
    )
}

const roundToTwo = (num) => {    
    return +(Math.round(num + "e+2")  + "e-2");
}

let panels =[]
let batterys = []
//let accontrollers = []

class CalcResults extends React.Component {
    constructor(props) {

        super(props)
        var sc = props.systemcost??10000.00;
        this.state = {
            flg_id: props.flg_id,
            origprops: props,      // Copy of the initial props sent to this Class
            token: props.token,    // Logon Token that has been created.
            postcode:   props.postcode,      // This is the address of the property - this is used to calc iradiance figures
            currency: "£",              // Currency that we are working with
            solarsavingkwp: 0,          // Total KWpH Savings from solar over 30 years
            solarsavingcur: 0.00,       // Total £ savings from solar over 30 years
            batterysavingkwp: 0,        // Total KWpH Savings from a Solar Battery system
            batterysavingcur: 0.00,     // Total £Savings from a Solar Battery system
            extrasavingkwp: 0,          // Extra KWpH Savings from a Voltage optimizer etc system
            extrasavingcur: 0.00,       // Extra £ Savings from a Voltage optimizer etc system
            //elecrate: props.elecrate,  // Current price of Electricity
            elecconsumption: props.elecconsumption,             // Anual Electric consumption from current Electric bill
            elec_annual_increase: props.elec_annual_increase,   // Annual electricty prices increase (%) year on year
            gasconsumption:  props.gasconsumption,               // Anual GAS consumption for current GAS Bill
            gasrate:        props.gasrate,                      // Cost per KWpH Gas
            gas_estimated:  props.gas_estimated,
            //electric_estimated: props.electric_estimated,
            yr1solarsavingkwp: 0,       // KWpH Savings in Year 1 from Solar
            yr1solarsavingcur: 0.00,    // £ Savings in Year 1 from Solar
            yr1batterysavingkwp: 0,     // KWpH Savings in Year 1 from Battery
            yr1batterysavingcur: 0.00,  // £ Savings in Year 1 from Solar
            yr1extrasavingkwp: 0,       // KWpH Savings in Year 1 from Extras such as Voltage Optimizer
            yr1extrasavingcur: 0.00,    // £ Savings in Year 1 from Extras such as Voltage Optimizer
            totalmoney30: 0.00,         // Total £ savings over 30 years from Solar, Battery and Extras
            totalkwph30: 0,             // Total KWpH savings over 30 years from Solar, Battery and Extras
            savings: [],                // Savings for each of the 30 years broken down by year
            errOpen:    false,
            errTitle: '',
            errText: '',
            vo: props.vo,
            battery: props.battery,
            selfconsumption: props.selfconsumption,
            financeOptions: [],
            financeoption: props.financeoption,
            financeterm: typeof props.financeterm !== "undefined" ? props.financeterm : 6,
            maintenanceoptions: [],
            selectedFinance: 0,
            selectedFinanceTerm:  typeof props.financeterm !== "undefined" ? props.financeterm : 6,
            systemcost: sc,
            calculating: false,
            has_voltageoptimser: (props.vo && props.vo>0) ? true : false,
            has_iboost: props.has_iboost,
            has_smart_thermostat: props.has_smart_thermostat,
            has_smart_energy: false,
            has_boiler_manager: props.has_boiler_manager,
            selected_tariff: props.selected_tariff,
            selected_maintenance: props.selected_maintenance,
            calcterm: 25,   // Default to 25 Years if we cannot read the config file.
            yr1_batteryandsolar_benefit: 0.00,
            yr1_smartproduct_benefit: 0.00,
            yr1_smartexport_benefit: 0.00,
            yr1_smarttariff_benefit: 0.00,
            avg_batteryandsolar_benefit: 0.00,
            avg_smartproduct_benefit: 0.00,
            avg_smartexport_benefit: 0.00,
            avg_smarttariff_benefit: 0.00,            
            avg_total: 0.00,
            avg_anual_roi: 0.00,
            selectedTab: 0,
            saletype: 'PHONE',
            total_system_cost: 0,
            total_benefit: 0,
            total_profit: 0,
            average_monthly_net_contribution: 0,
            email: props.email,
            full_name: props.full_name,
            first_name: props.first_name,
            address: props.address,
            rep_name: props.rep_name,
            rep_email: props.rep_email,
            line_items: [],         // This is a text array listing what the customer is buying  
            system_cost_30day: sc,
            system_cost_privilege: sc - pdfc.priv_discount ,
            system_cost_7day: sc - pdfc.phone_discount,
            system_cost_discount: (sc - pdfc.phone_discount - pdfc.phone_discount_offer3),
            system_cost_nooffer: (props.systemcost- pdfc.phone_discount),
            system_cost_discount450: (props.systemcost - pdfc.phone_discount - pdfc.phone_discount_offer4),
            merge_completed: false,
            offers: json_offer,
            offertype: '',
            offerid: props.offerid ? props.offerid : '7 Day Offer 5',
            slides: [],
            calculations_run: false,
            show_calculations_run: false,
            filelist: props.filelist,
            net_cost: this.getOfferSystemCost(props.offerid ? props.offerid : '7 Day Offer 5',sc),
            required_inverters: props.required_inverters ? JSON.parse(JSON.stringify(props.required_inverters)) : [],
            evcharger: typeof props.evcharger !== "undefined" ? props.evcharger : null,
            net_cost: typeof props.net_cost !== "undefined" ? props.net_cost  : 0,
            selfgen:  typeof props.selfgen !== "undefined" ? props.selfgen  : false,         // Self Generated Lead for commission purposed
            vat: typeof props.vat !== "undefined" ? props.vat  : vat_rate,                 // Currently 5%
            commperc: typeof props.commperc !== "undefined" ? props.commperc  : 8,            // Default Comms Percentage 
            comm_sacrifice: typeof props.comm_sacrifice !== "undefined" ? props.comm_sacrifice  : 0,      // Any Reps Sacrificied commission due to offers etc
            additional_discount: typeof props.additional_discount !== "undefined" ? props.additional_discount  : 0, // Additional Discount offers
            delivery_miles: typeof props.delivery_miles !== "undefined" ? props.delivery_miles  : 100,
            hardGround: props.hardGround,
            softGround: props.softGround,
            create_documents: typeof props.create_documents !== "undefined" ? props.create_documents  : false,        // Only produces PDF Presentation and other docs when checked.
            dont_update_base: typeof props.dont_update_base !== "undefined" ? props.dont_update_base  : false,        // If Checked teh Base Price will not be updated from the Price Calculater.
            shared_discount: typeof props.shared_discount !== "undefined" ? props.shared_discount  : 0,             // Split Discount taken 50% WOS and 50% by Sales Rep.
            sellprice: this.getOfferSystemCost(props.offerid ? props.offerid : '7 Day Offer 5',sc) - (props.shared_discount ??0), 
            show_alert: false,
            alert_text: '',
            limiterRequired: 0,
            extra_order_info: typeof props.extra_order_info !== "undefined" ? props.extra_order_info : '',
            pricing_out: [],
            component_mounted: false,
            presentation_versions: typeof props.presentation_versions !== "undefined" ? props.presentation_versions : [],
            selected_presentation: `${props.flg_id}.pdf`,
            ancillary_items: typeof props.ancillary_items !== "undefined" ? props.ancillary_items : [],
            finance_charge: 0, // typeof props.finance_charge !== "undefined" ? props.finance_charge : 0,
            batteryonly: typeof props.batteryonly !== "undefined" ? props.batteryonly : false,
            accontroller: typeof props.accontroller !== "undefined" ? props.accontroller : null,
            admin: false,
            manager: false,
            addition_scaff: 1,
            customer_message_top: '',
            customer_message_footer: '',
            birdprotection_cnt: 0,
            force_pdf_reload: Date.now(),
            show_adobe: false,
            adobe_severity: 'success',
            adobe_text: '',
            agreement_version: 1,
            show_agreement: true,
            totals: {},
            avg_monthly_savings: '',
            hold_base_price: props.hold_base_price??0,
            sweep_sale: props.sweep_sale,
        }

        for(var i=0; i<25; i++)
            financeTerms[i] = {uid: i, description: i===0 ? '1 Year' : (i+1) + ' Years'}
    }

    // Check to see if any of the props passed in have changed
    static getDerivedStateFromProps = (nextProps, prevState) =>{

        const flg_id = prevState.flg_id
        const selected_presentation = `${flg_id}.pdf`
        let ancillary_items = []

        // do things with nextProps.someProp and prevState.cachedSomeProp
        if((prevState.origprops!== nextProps) ) {
            console_log("getDerivedStateFromProps")
            console_log(prevState)
            console_log(nextProps)
            let offerid ='7 Day Offer 5';
            if(nextProps.offerid > "")
                offerid = nextProps.offerid 
            let sellprice = nextProps.sellprice
            if(sellprice <=0 || sellprice == "") {
                var sc = nextProps.systemcost ? nextProps.systemcost : '10000.00'; 
                if(this.state.dont_update_base && (nextProps.hold_base_price??0) > 0 )
                    sc =  nextProps.hold_base_price          
                let offer_discount = this.GetOfferDiscount(this.state.offerid)
                let additional_discount = pdfc.phone_discount - (offer_discount ?? pdfc.phone_discount)
                let vat = this.state.vat
        
                const nc = this.getOfferSystemCost(offerid, sc)
                let sellprice = ((nc - additional_discount) * (1+ (vat/100))) - (this.state.shared_discount??0) 
        
            }
            let birdprotection_cnt = 0
            const panlength = nextProps.panelArrays.length;
            for(var i=0; i<panlength; i++) {
                const numPanels = parseInt(nextProps.panelArrays[i].numPanels)
                const birdprotection = nextProps.panelArrays[i].birdprotection
                birdprotection_cnt += birdprotection ? numPanels : 0
            }
            return {
                origprops: nextProps,
                savings: nextProps.savings,
                //elecrate: nextProps.elecrate,
                elecconsumption: nextProps.elecconsumption,
                elec_annual_increase: nextProps.elec_annual_increase,
                financeterm: nextProps.financeterm,
                selectedFinanceTerm: nextProps.financeterm,
                gasconsumption: nextProps.gasconsumption,
                gasrate: nextProps.gasrate,
                token: nextProps.token,
                vo: nextProps.vo,
                selfconsumption: nextProps.selfconsumption,
                battery: nextProps.battery,
                has_voltageoptimser: (nextProps.vo  && nextProps.vo >0) ? true:false,
                has_iboost: nextProps.has_iboost,
                has_smart_thermostat: nextProps.has_smart_thermostat,
                has_smart_energy: nextProps.has_smart_energy,
                has_boiler_manager: nextProps.has_boiler_manager,
                selected_tariff: nextProps.selected_tariff,
                systemcost: nextProps.systemcost ? nextProps.systemcost : '',
                //sellprice: sellprice,
                postcode: nextProps.postcode,
                flg_id: nextProps.flg_id,
                financeoption: nextProps.financeoption,
                //electric_estimated: nextProps.electric_estimated,
                gas_estimated:  nextProps.gas_estimated,
                selected_maintenance: nextProps.selected_maintenance,
                system_cost_30day: nextProps.systemcost ,
                system_cost_privilege: nextProps.systemcost - pdfc.priv_discount,
                system_cost_7day: nextProps.systemcost  - pdfc.phone_discount, 
                system_cost_discount: nextProps.systemcost ? (nextProps.systemcost  - pdfc.phone_discount-pdfc.phone_discount_offer3) : 0,
                system_cost_nooffer: (nextProps.systemcost - pdfc.phone_discount),
                system_cost_discount450: nextProps.systemcost ? (nextProps.systemcost - pdfc.phone_discount - pdfc.phone_discount_offer4) : 0,
                full_name: nextProps.full_name,
                first_name: nextProps.first_name,
                rep_name: nextProps.rep_name,
                rep_email: nextProps.rep_email,
                address: nextProps.address,
                slides: nextProps.slides,
                filelist: nextProps.filelist,
                offerid: offerid,
                evcharger: typeof nextProps.evcharger !== "undefined" ? nextProps.evcharger : null,
                hardGround: nextProps.hardGround,
                softGround: nextProps.softGround,
                net_cost: typeof nextProps.net_cost !== "undefined" ? nextProps.net_cost : 0,
                selfgen:  typeof nextProps.selfgen !== "undefined" ? nextProps.selfgen  : false,         
                vat: typeof nextProps.vat !== "undefined" ? nextProps.vat  : vat_rate,   
                finance_charge: 0, // typeof nextProps.finance_charge !== "undefined" ? nextProps.finance_charge : 0,              
                commperc: nextProps.commperc??0,          
                comm_sacrifice: typeof nextProps.comm_sacrifice !== "undefined" ? nextProps.comm_sacrifice  : 0,
                additional_discount: typeof nextProps.additional_discount !== "undefined" ? nextProps.additional_discount  : 0,
                delivery_miles: typeof nextProps.delivery_miles !== "undefined" ? nextProps.delivery_miles  : 100,
                create_documents: typeof nextProps.create_documents !== "undefined" ? nextProps.create_documents  : false,
                dont_update_base: typeof nextProps.dont_update_base !== "undefined" ? nextProps.dont_update_base  : false, 
                shared_discount: typeof nextProps.shared_discount !== "undefined" ? nextProps.shared_discount  : 0 ,
                extra_order_info: typeof nextProps.extra_order_info !== "undefined" ? nextProps.extra_order_info : '',
                presentation_versions: typeof nextProps.presentation_versions !== "undefined" ? nextProps.presentation_versions : [],
                selected_presentation: typeof nextProps.selected_presentation !== "undefined" ? nextProps.selected_presentation : selected_presentation,
                required_inverters: typeof nextProps.required_inverters !== "undefined" ? nextProps.required_inverters : [],
                ancillary_items: typeof nextProps.ancillary_items !== "undefined" ? nextProps.ancillary_items : prevState.orig_props.ancillary_items,
                accontroller: typeof nextProps.accontroller !== "undefined" ? nextProps.accontroller : null,
                batteryonly: typeof nextProps.batteryonly !== "undefined" ? nextProps.batteryonly : false,
                birdprotection_cnt: birdprotection_cnt,
                sweep_sale: nextProps.sweep_sale??false,
            }
        }
        return null
    }

    componentDidMount = async () => {
        let admin = false
        let manager = this.state.manager??false            

        try {
            json = await APIGetJSONMappings()
            pdf_pages = new PDFPages(json)
            panels =  await GetPanels()
            batterys = await GetBatterys()
            //accontrollers = await APIGetAllACControllers()
            ancillarycosts = await APIAncillaryCosts()
            fixedcosts = await APIFixedCosts()
            mountingHardwareMap = await APIMountingHardwareMap()

            // Hydrate pricing_config so the calc reads admin-managed offer discounts,
            // VAT rates, commission policy, etc. from the DB instead of pdf_configs.js.
            // Falls back to pdf_configs values via the cfg() helper if a row is missing.
            try {
                const cfgRows = await APIPricingConfig()
                pricingConfig.clear()
                for (const row of (cfgRows || [])) {
                    if (row && row.key) pricingConfig.set(row.key, row)
                }
            } catch (err) {
                console_log("pricing_config hydrate skipped: " + (err && err.message))
            }

            // Pull active product_suppliers rows for every product type that has an
            // associated catalogue and build per-type best-priced lookup maps. Then
            // overlay each catalogue array in place so every downstream consumer
            // (legacy lineitems push, mounting-map pushMappedItem/pushMountingPart,
            // BOM job sheet) sees the real supplier costs. Fixedcosts is excluded —
            // those are MT Solar's own internal flat costs, not supplier-sourced.
            try {
                const productTypes = ['panels', 'batterys', 'inverters', 'evchargers', 'ancillaries']
                await Promise.all(productTypes.map(async (productType) => {
                    const rows = await APIProductSuppliersForType(productType)
                    const grouped = new Map()
                    for (const row of (rows || [])) {
                        if (!row || row.product_id == null) continue
                        const list = grouped.get(row.product_id) || []
                        list.push(row)
                        grouped.set(row.product_id, list)
                    }
                    const best = new Map()
                    for (const [productId, list] of grouped) {
                        const row = pickBestSupplierRow(list)
                        if (row) best.set(productId, row)
                    }
                    productSupplierMaps[productType] = best
                }))

                const overlayCatalogue = (catalogue, productType, idField) => {
                    if (!Array.isArray(catalogue)) return
                    const map = productSupplierMaps[productType]
                    if (!map || map.size === 0) return
                    catalogue.forEach(item => {
                        if (!item) return
                        const id = item[idField]
                        const row = map.get(id)
                        if (!row) return
                        const cost = parseFloat(row.unit_cost)
                        if (Number.isFinite(cost)) {
                            item.unit_cost = cost
                            item.item_cost = cost
                            // Only fill customer_price if the doc didn't already have one.
                            // (Customer-facing markup is a separate question we don't want
                            //  to silently overwrite on existing items.)
                            if (item.customer_price == null || item.customer_price === 0) {
                                const inc = parseFloat(row.unit_cost_inc_vat)
                                if (Number.isFinite(inc)) item.customer_price = inc
                            }
                        }
                        item.supplier_id = row.supplier_id
                        item.supplier_sku = row.supplier_sku
                        item.supplier_stock_status = row.stock_status
                    })
                }

                // Locally-loaded catalogues only — the maps for inverters/evchargers are
                // still populated above and consumed via supplierUnitCost at the
                // lineitem push sites (their catalogues live in QuotePageApp).
                overlayCatalogue(panels, 'panels', 'panel_id')
                overlayCatalogue(batterys, 'batterys', 'battery_id')
                overlayCatalogue(ancillarycosts, 'ancillaries', 'ac_id')
            } catch (err) {
                console_log("supplier price overlay skipped: " + (err && err.message))
            }
            const site_id = this.props.selected_site??0

            const agreement_version = await APIGetAgreementVersion({flg_id: this.state.flg_id, site_id: this.props.selected_site})

            let postcode = this.state.postcode
            if(this.props && this.props.postcode) postcode = this.props.postcode
            
            const ret = await  this.getActualMiles(postcode)
            let delivery_miles = ret.delivery_miles

            const logon = await APIloggedin()

            let rep_name = ''
            let rep_email =''

            if(typeof logon !== "undefined" && typeof logon.admin !== undefined) {
                admin = logon.admin
                rep_name = logon.rep_name
                rep_email = logon.rep_email
                manager = logon.manager??false
            }
            //console_log(json_offer);
            let savings = []
            let panelArrays = []
            let token = null
            let {vo,selfconsumption, elecconsumption,gasrate,gasconsumption,elec_annual_increase, battery,
                has_voltageoptimser,has_iboost,has_smart_thermostat,has_smart_energy,has_boiler_manager,
                selected_tariff, systemcost, flg_id, financeoption, financeterm, gas_estimated,selected_maintenance,
                full_name,first_name, address, system_cost_30day, system_cost_privilege, system_cost_7day,system_cost_discount,system_cost_nooffer,system_cost_discount450, slides, filelist, offerid, 
                required_inverters, hardGround, softGround,net_cost,selfgen,commperc,comm_sacrifice,
                create_documents, dont_update_base, shared_discount, presentation_versions, ancillary_items, finance_charge,
                customer_message_top,customer_message_footer
            } = this.state
            let additional_discount = this.state.additional_discount
            let vat = this.state.vat
    
            const rates = await getFinanceRates()                           // Get available Finance rates from the DB
            const maintenanceoptions = await GetMaintenanceOptions()        // Get available Maintenance options fron the DB
            

            let props = this.props
            if(props ) {
                if(typeof props.savings !== "undefined")                savings = JSON.parse(JSON.stringify(props.savings))
                if(props.token)                                         token = JSON.parse(JSON.stringify(props.token))   
                if(typeof props.vo !== "undefined")                     vo = props.vo
                if(typeof props.selfconsumption !== "undefined")        selfconsumption = props.selfconsumption
                //if(typeof props.elecrate !== "undefined")               elecrate = props.elecrate
                if(typeof props.elecconsumption !== "undefined")        elecconsumption = props.elecconsumption
                if(typeof props.elec_annual_increase !== "undefined")   elec_annual_increase = props.elec_annual_increase
                if(typeof props.gasconsumption !== "undefined")         gasconsumption = props.gasconsumption
                if(typeof props.gasrate !== "undefined")                gasrate = props.gasrate
                if(typeof props.battery !== "undefined")                battery = props.battery
                                                                        has_voltageoptimser = (props.vo && props.vo>0) ? true:false;
                if(typeof props.has_iboost !== "undefined")             has_iboost = props.has_iboost
                if(typeof props.has_smart_thermostat !== "undefined")   has_smart_thermostat = props.has_smart_thermostat
                if(typeof props.has_smart_energy !== "undefined")       has_smart_energy = props.has_smart_energy
                if(typeof props.has_boiler_manager !== "undefined")     has_boiler_manager = props.has_boiler_manager
                if(typeof props.selected_tariff !== "undefined")        selected_tariff = props.selected_tariff
                if(typeof props.systemcost !== "undefined")             systemcost = props.systemcost
                if(props.flg_id)                                        flg_id = props.flg_id
                if(typeof props.financeoption !== "undefined")          financeoption= props.financeoption
                if(typeof props.financeterm !== "undefined" )           financeterm = props.financeterm
                if(typeof  props.gas_estimated !== "undefined")         gas_estimated = props.gas_estimated
                //if(typeof props.electric_estimated !== "undefined")     electric_estimated = props.electric_estimated
                if(typeof props.selected_maintenance !== "undefined")   selected_maintenance=props.selected_maintenance
                if(props.full_name)                                     full_name = props.full_name
                if(props.first_name)                                    first_name = props.first_name
                if(props.address)                                       address = props.address
                if(typeof props.slides !== "undefined")                 slides = props.slies
                if(typeof props.filelist !== "undefined")               filelist = props.filelist
                if(props.hardGround )                                   hardGround = props.hardGround
                if(props.softGround )                                   softGround = props.softGround
                if(props.offerid)                                       offerid = props.offerid
                if(props.required_inverters)                            required_inverters = JSON.parse(JSON.stringify(props.required_inverters))
                //if(props.ancillary_items)                               ancillary_items = props.ancillary_items
                if( systemcost > 0 ) {
                    system_cost_30day = systemcost
                    system_cost_privilege = systemcost  - pdfc.priv_discount
                    system_cost_7day = systemcost - pdfc.phone_discount
                    system_cost_discount = (systemcost - pdfc.phone_discount - pdfc.phone_discount_offer3)
                    system_cost_discount450 = (systemcost - pdfc.phone_discount - pdfc.phone_discount_offer4)
                    system_cost_nooffer = (systemcost - pdfc.phone_discount)
                }
                if(props.net_cost  )                    net_cost = props.net_cost
                if(props.selfgen  )                     selfgen = props.selfgen          // Self Generated Lead for commission purposed
                if(props.vat )                          vat = props.vat                 
                if(props.finance_charge )               finance_charge = 0 // props.finance_charge
                if(props.commperc  )                    commperc = props.commperc            // Default Comms Percentage 
                if(props.comm_sacrifice )               comm_sacrifice = props.comm_sacrifice      // Any Reps Sacrificied commission due to offers etc
                if( props.additional_discount)          additional_discount = props.additional_discount   // Additional Discount offers
                if( props.delivery_miles  )             delivery_miles = props.delivery_miles
                if( props.create_documents  )           create_documents = props.create_documents        // Only produces PDF Presentation and other docs when checked.
                if( props.dont_update_base  )           dont_update_base = props.dont_update_base         // If Checked teh Base Price will not be updated from the Price Calculater.
                if( props.shared_discount )             shared_discount = props.shared_discount               // Split Discount taken 50% WOS and 50% by Sales Rep.
                if( props.presentation_versions)        presentation_versions = props.presentation_versions
            }

            if((typeof props.financeoption == "undefined" || financeoption == null ) && typeof rates !== "undefined" && rates.length > 0)         
                financeoption=JSON.parse(JSON.stringify(rates[0]))
            else if( (typeof props.financeoption == "undefined" || financeoption == null) & rates.length > 0 )
                financeoption=JSON.parse(JSON.stringify(rates[0]))
            
            if(financeoption == "undefined")
                financeoption=JSON.parse(JSON.stringify(rates[0]))

            if( offerid == "" || offerid <=0 )
                offerid ='7 Day Offer 5';

            var sc = systemcost ? systemcost : 10000.00;
            if(this.state.dont_update_base && (this.state.hold_base_price??0) > 0 )
            sc =  this.state.hold_base_price 
            //let  = sc
            //if(props.batteryonly == false)
            let offer_discount = this.GetOfferDiscount(this.state.offerid)
            additional_discount = pdfc.phone_discount - (offer_discount ?? pdfc.phone_discount)
            vat = this.state.vat
    
            const nc = this.getOfferSystemCost(offerid, sc)??0
            let sellprice = ((nc - additional_discount) * (1+ (vat/100))) - (this.state.shared_discount??0) 
    
            // Get the saletype from teh offer id
            let saletype=this.state.saletype
            const jsonofferlength = json_offer.length;
            for(var x=0; x<jsonofferlength; x++) {
                //console_log(json_offer[x].offer + " - " + offerid + " (" + props.offerid + " )")
                if(json_offer[x].offer === offerid)
                    saletype = json_offer[x].type
            }
            // If this is a battery only install shared discount is not allowed so make sure its zero
            if(this.state.batteryonly == true) {
                shared_discount = 0
                vat  = pdfc.commercial_vat_rate
            }

            var selected_finance = 0
            let invbad = false
            const rateslength = rates.length;
            if(typeof rates !=="undefined" && rateslength > 0 && financeoption ) 
                for(var i=0; i<rateslength; i++) 
                    if(rates[i].uid === financeoption.uid) {
                        selected_finance = i;
                        financeoption = JSON.parse (JSON.stringify(rates[i]))
                        if((financeoption.bnpl_years??0) > 0 )
                            financeterm = financeoption.bnpl_years-1

                    }
            const rit = required_inverters
            let retinv = {}
            if(rit && rit.length > 0 && typeof rit[0].inverter !== "undefined" && rit[0].inverter.id == -2) {
                retinv = {errText: "",errTitle: "", errOpen: false}
            }else {
                if(this.state.batteryonly == false) {                   
                    retinv = await CalcInverters(required_inverters, battery,this.props.panelArrays, offerid, this.props.is3phase,  this.props.offgrid)
                    if( retinv && typeof retinv !== "undefined" && retinv.status) {
                        console_log('retinv defined')
                        console_log(retinv)
                        const retinvlength = retinv.required_inverters.length;
                        for(let i=0; i<retinvlength; i++)
                            if(typeof retinv.required_inverters[i].inverter.id == "undefined")
                                invbad = true
                        required_inverters = JSON.parse(JSON.stringify(retinv.required_inverters))
                        retinv = {errText: "",errTitle: "", errOpen: false}
        
                    }else {
                        if(this.props.panelArrays == null || typeof this.props.panelArrays == "undefined" || this.props.panelArrays.length == 0) {
                            // No Arrays have been setup so no error.
                            retinv = {errText: "",errTitle: "", errOpen: false}
                        }else {
                            invbad = true
                            retinv = {errText: "One or more Inverter Type could not be Calculated. Please Check Inverters and Select manually",
                                        errTitle: "Error Calculatin Inverter Type. Check Inveters!!", errOpen: true}
                        }
                    }
                }else {
                    required_inverters = JSON.parse(JSON.stringify(this.state.required_inverters))
                }
            }
                            
            retinv.calculating = false
            let birdprotection_cnt = 0
            const proppanlength = props.panelArrays.length;
            for(var i=0; i<proppanlength; i++) {
                const numPanels = parseInt(this.props.panelArrays[i].numPanels)
                const birdprotection = this.props.panelArrays[i].birdprotection
                birdprotection_cnt += birdprotection ? numPanels : 0
            }

            customer_message_top = `${first_name}\n\nPlease find as discussed, version [--VERSION--] of your MT Solar Agreement for your electronic signature.`
            customer_message_footer = `If you have any questions or need help please do not hesitate to give me a call\n\nKind Regards\n\n${rep_name}\n\n`
            this.setState({savings,token,vo, selfconsumption,elec_annual_increase,battery, elecconsumption,
                has_voltageoptimser,has_iboost,has_smart_thermostat,has_smart_energy,has_boiler_manager,selected_tariff,systemcost,
                postcode, flg_id, financeOptions: rates, maintenanceoptions, gasconsumption, gasrate, financeoption, gas_estimated, 
                calculating: false,selected_maintenance, selected_finance, full_name, address,
                selectedFinanceTerm: financeterm, financeterm,system_cost_30day, system_cost_privilege, system_cost_7day,system_cost_discount,
                system_cost_nooffer,system_cost_discount450, filelist, slides, offerid, saletype, sellprice, errOpen: false, 
                required_inverters, softGround, hardGround, delivery_miles, net_cost,selfgen,vat,finance_charge, commperc,comm_sacrifice,additional_discount,delivery_miles,
                create_documents,dont_update_base,shared_discount, component_mounted: true, ancillary_items,
                presentation_versions,errOpen: retinv.errOpen, calculating: retinv.calculating,  errText: retinv.errText, errTitle: retinv.errTitle, admin,
                customer_message_top, customer_message_footer, rep_name, rep_email, birdprotection_cnt, agreement_version, admin,manager
            },() => { this.isLimmiterRequired() })
            /* Removed the following from setState 
                singlepase_consumer_unit,battery_plug,singlepase_consumer_unit,battery_plug,landScapePanels, sofarWarrantyUpgrade
            */
        }catch(e) {
            console.log("******** ERROR COMPONENT DID NOT MOUNT ********")
            console.log(e)
            this.setState({admin,manager, errOpen: true, errTitle: 'Serious Error Report to IT', errText: `The Component did not Complet Mounting in CalcResults. This means that prices and presentations WILL BE incorrect. Please report this Error Urgently to the IT Department.  System Reported Error ${e}` })
        }
    }

    getActualMiles = async (postcode) => {
        let error = "Could not get Delivery miles so the value is left the same"
        let status = false
        let delivery_miles = this.state.delivery_miles
        try {
            // Delivery from Chichester (Office 1)
            var distance = await APIGetDirections("PO19+1HL",postcode.replace(" ","+"))
            let delivery_miles = this.state.delivery_miles??100
            if(distance && typeof(distance) !== "undefined" && typeof(distance["distanceval"]) !== "undefined" ) {
                if(!isNaN(distance["distanceval"])) {
                    delivery_miles = parseInt( (parseInt(distance["distanceval"]) / 1609.34) + 0.5); 
                    status = true
                    error = ''
                }
            }
            // DELIVERY FROM CHICHESTER
            var distance2 = await APIGetDirections("PO19+1HL",postcode.replace(" ","+"))
            let delivery_miles2 = this.state.delivery_miles??100
            if(distance2 && typeof(distance2) !== "undefined" && typeof(distance2["distanceval"]) !== "undefined" ) {
                if(!isNaN(distance2["distanceval"])) {
                    delivery_miles2 = parseInt( (parseInt(distance2["distanceval"]) / 1609.34) + 0.5); 
                    status = true
                    error = ''
                }
            }

            if(status && error == '' && delivery_miles2 > delivery_miles)
                return( {status, delivery_miles: delivery_miles2, error});  // Select Essex Delivery
            else
                return( {status, delivery_miles, error});   // Select Chichester Delivery

        }catch(err) {
            console_log(err)
            status = false
            error += `. Error code ${err}`
            return( {status, delivery_miles, error});
        }

    }

    // Close the Error dialog box
    handleErrDaialogClose = (value) => {
        this.setState({errOpen: false})
    }

    // Handle Change of Finance Terms
    handleFinanceOptions = e => {
        let value = e.target.value;
        if(!this.state.financeOptions || this.state.financeOptions.length === 0)
            return;

        // find finaceoptions matching the ID passed into function - Ensure we have the upto date terms.
        const fo = this.state.financeOptions.find(e => e.uid === value)
        if((fo??null)) {
            let selectedFinanceTerm = this.state.selectedFinanceTerm
            let financeterm = this.state.financeterm
            // If we have Buy Now Pay Later (bnpl) adjust the terms of the loan to the bnpl terms
            if((fo.bnpl_years??0) > 0) {
                selectedFinanceTerm = fo.bnpl_years -1
                financeterm = fo.bnpl_years-1
            }
            // Update the state and then push data back to the parent.
            this.setState({financeoption: fo, selectedFinanceTerm })
            const {savings, selected_maintenance,systemcost,slides,filelist, offerid, required_inverters,
                net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount,
                extra_order_info, presentation_versions, selected_presentation, ancillary_items, finance_charge
            } = this.state
            // Push changes back to the calling Parent.
            this.props.onChange({financeterm, financeoption: fo, savings, selected_maintenance,systemcost,slides,filelist, offerid, required_inverters,
                net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount, 
                extra_order_info, presentation_versions, selected_presentation, ancillary_items, finance_charge
            })            
        }
    }

    // If we have a 2nd customer get the email address for the order to be sent to.
    updateCustomer2Email = e => {
        this.props.updatecustomer2email(e.target.value)   
    }

    // If we have a 2nd customer get the customers first name for the order form
    updateCustomer2Name = e => {
        this.props.updatecustomer2name(e.target.value)
    }

    // If we have a 2nd customer get the customers surname name for the order form
    updateCustomer2Surname = e => {
        this.props.updatecustomer2surname(e.target.value)
    }    

    // If we have a 2nd customer get the customers title for the order form
    updateCustomer2Title = e => {
        this.props.updatecustomer2title(e.target.value)
    }    

    // Update the selected maintenance options.
    handleMaintenanceOptions = e => {
        let value = e.target.value;
        const selected_maintenance = this.state.maintenanceoptions.find(e => e.maintenance_id === value)

        if(selected_maintenance) {
            const {financeterm, financeoption, savings, systemcost,slides,filelist, offerid, required_inverters,
                net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount,
                extra_order_info, presentation_versions, selected_presentation, ancillary_items, finance_charge
            } = this.state

            this.props.onChange({financeterm, financeoption, savings, selected_maintenance,systemcost,slides,filelist, offerid, required_inverters,
                net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount, 
                extra_order_info, presentation_versions, selected_presentation, ancillary_items, finance_charge
            })  
        }
    }
    
    // Update Redux with listed property type
    handleListedProperty  = e => {
        let value = e.target.value;
        this.props.updatelistedproperty(value)
    }

    // Update Redux with Conservation Area type
    handleConservationArea = e => {
        let value = e.target.value;
        this.props.updateconservationarea(value)
    }

    // Hanle change to finance terms
    handleFinanceTerm = e => {
        // Do not allow term to be changed on BNPL with fixed Terms/
        if(this.state.financeoption && (this.state.financeoption.bnpl_years??0) > 0)
            return;
        // Update state with latest finance term.
        let financeterm = e.target.value;
        this.setState({selectedFinanceTerm: financeterm, financeterm})  
        
        let finance_charge = 0  // This was removed so need to insure it is always set to zero
        const {financeoption, savings, selected_maintenance,systemcost,slides,filelist, offerid, required_inverters,
            net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount,
            extra_order_info, presentation_versions, selected_presentation, ancillary_items
        } = this.state
        // Update parent with changes
        this.props.onChange({financeterm, financeoption, savings, selected_maintenance,systemcost,slides,filelist, offerid, required_inverters,
            net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount, 
            extra_order_info, presentation_versions, selected_presentation, ancillary_items, finance_charge
        })  

    }

    // Handle change in the system (base price) cost - Unless do not overide base check box is checked at the bottom
    // of the Price tab this will be overwritten everytime Calculate is run.
    handleSystemCost = e => {
        let value = e.target.value;
        this.updateSystemCost(value)
    }

    // Handle a chane in deposit amount
    handleDeposit = e => {
        this.props.updatedeposit(e.target.value)
    }

    // Hande change between Domestic and Commercial propertys and udpate the correct vat rate for the selected one.
    handlePropertyType = e => {
        this.props.updatepropertytype(e.target.value)
        if(e.target.value == 'Commercial')
            vat_rate = pdfc.commercial_vat_rate
        else    
            vat_rate = pdfc.vat_rate
        this.setState({vat: vat_rate})
    }

    // Capture the MPAN Number -> Stored in redex
    handleMPAN = e => {
        this.props.updatempan(e.target.value)
    }

    // Code to update system (base price) cost
    updateSystemCost = value => {
        //console.log(`updateSystemCost ${value}`)
        if(isNaN(value) || value == "")
            value = 0
        else if(typeof value === "string") 
            value = Number(value)
        else if( value<0 )
            value= 10000
        if(value > 2000000) {
            this.setState({
                errOpen: true,
                errTitle: 'Check System Price!',
                errText: 'Just a Check to make sure you have entered the correct amount for the System Price?',
                systemcost: value
            })
        }
        else {
            if(value >= 0 || value === "") {
                if(isNaN(value) || value == "") value = 0 // Default to 0 if Not a Number
                // Update all of the discounted price versions
                const system_cost_30day= value 
                const system_cost_privilege = value - pdfc.priv_discount
                const system_cost_7day = value - pdfc.phone_discount
                const system_cost_discount = (value - pdfc.phone_discount - pdfc.phone_discount_offer3)
                const system_cost_nooffer = (value - pdfc.phone_discount)
                const system_cost_discount450 = (value - pdfc.phone_discount - pdfc.phone_discount_offer4)
                this.setState({systemcost: value,system_cost_30day, system_cost_privilege, system_cost_7day, system_cost_discount, system_cost_nooffer,system_cost_discount450, errOpen: false })

            }
        }
    }    
    // Handel self gen marketing  checked
    handleSelGen = e => {
        this.setState({selfgen: e.target.checked},() => { this.updateParent() })
    }

    handleSweepSale = e => {
        if(e.target.checked) 
            this.setState({commperc: 0, commission: 0, selfgen: 0,sweep_sale: e.target.checked},() => { this.updateParent() })
        else
            this.setState({sweep_sale: e.target.checked},() => { this.updateParent() })
    }
    
    // Hand reps commission percentage. *** This will be migrated to MongoDB and Reps will not be allowed to change this % ***
    handleComsPerc = e => {
        if( !isNaN(e.target.value)) {
            this.setState({commperc: e.target.value}, () => { this.updateParent() })
            
        }
    } 

    // handle a manual change to the delivery miles being calculated.
    handleDeliveryMiles = e => {
        let value = (isNaN(e.target.value) || e.target.value == "") ? 0 : parseInt(e.target.value)
        // Push to Redux addons slice first — parent's syncStateToRedux only syncs addons
        // on initial load, so without this the next render's getDerivedStateFromProps
        // would reset delivery_miles back to the slice value.
        this.props.setDeliveryMiles(value)
        this.setState({delivery_miles: value}, () => { this.updateParent() })
    }

    // Handle EXtra Info being added to the order for the order form.
    handleAdditionOrderinfo = e => {
        var text = e.target.value;
        var newText = '';
        var lines = 0;
        var ipos = 1;
        var iWrap = 70;     // Wrap text after 70 characters
        var iLines = 11;    // Only allow a max of 11 lines of text.
        const txtlength = text.length;
        for(let i=0; i<txtlength; i++) {
            if(text[i] == '\n') {
                lines++
                ipos = 0
                if(lines> iLines)
                    return
                if(lines>(iLines-1) && ipos >iWrap)
                    return; 
            }
            if(ipos > iWrap && text[i] != '\n') {
                if(lines==iLines)
                    return
                newText += '\n'
                ipos=0
            }
            newText += text[i]
            ipos++
        }
        this.setState({extra_order_info:newText})
    }
    
    // Calculate delivery miles, if API cannot then default to 100 Miles.
    handleGetDeliveryMiles = async () => {
        let delivery_miles = 100
        let alert_text = "Could not calclate delivery miles. The Default 100 Miles has been set!"
        const ret = await  this.getActualMiles(this.state.postcode)
        console_log(ret);
        if(ret.status) {
            delivery_miles = ret.delivery_miles
            alert_text = `Delivery miles calculated as ${delivery_miles} Miles.`
        }
        this.props.setDeliveryMiles(delivery_miles)
        this.setState({show_alert: true, alert_text, delivery_miles}, () => { this.updateParent();})
    }

    // Admin-only: serialise the current lineitems into a CSV job sheet covering both
    // the supplier-priced bill of materials (cost of goods, ex-VAT) AND the
    // customer-price build-up (offer/discount/VAT) and the MT Solar margin
    // breakdown (commission, sacrifice, self-gen, fixed comms deduction). Lets us
    // verify nothing's missed and shows exactly how the customer price is derived.
    handleDownloadJobSheet = () => {
        const csvEscape = (val) => {
            if (val == null) return ''
            const s = String(val)
            return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
        }
        const fmt = (n) => (Number.isFinite(parseFloat(n)) ? parseFloat(n).toFixed(2) : '')
        const categoriseItem = (item) => {
            if (item.fc_id != null) return 'Fixed Cost'
            if (item.mounting_slot) return `Mounting (${item.mounting_slot})`
            if (item.panel_id != null) return 'Panel'
            if (item.battery_id != null) return 'Battery'
            if (item.solaredge != null) return 'SolarEdge'
            if (item.bird_id != null) return 'Bird Protection'
            if (item.installation_id != null) return 'Panel Fixing'
            if (item.uid != null) return 'Optimiser/Inverter'
            if (item.id != null) return 'Inverter'
            if (item.ac_id != null) return 'Ancillary'
            return ''
        }
        const noteFor = (item) => {
            const bits = []
            if (item.mounting_colour) bits.push(`colour=${item.mounting_colour}`)
            if (item.installation_id != null && !item.mounting_slot) bits.push(`installation_id=${item.installation_id}`)
            return bits.join(' ')
        }

        const rows = []

        // ---------- Header ----------
        rows.push(['Job Sheet'])
        rows.push(['Generated', new Date().toISOString()])
        rows.push(['FLG ID', this.state.flg_id || ''])
        rows.push(['Customer', this.state.full_name || this.state.name || ''])
        rows.push(['Address', this.state.full_address || this.state.address || ''])
        rows.push(['Postcode', this.state.postcode || ''])
        rows.push([])

        // ---------- Bill of Materials ----------
        // Supplier prices come through the product_suppliers overlay → unit_cost is the
        // cheapest active row's ex-VAT figure (STOCKS first, then HOLDS_STOCK, else any).
        rows.push(['Bill of Materials (Cost of Goods)'])
        rows.push(['All unit costs and line totals shown EX-VAT (supplier unit_cost).'])
        rows.push(['Item', 'Quantity', 'Unit Cost ex-VAT (£)', 'Line Total ex-VAT (£)', 'Category', 'AC ID', 'FC ID', 'Notes'])

        let costOfGoods = 0
        ;(lineitems || []).forEach(item => {
            if (item && item.skip === true) return
            const qty = parseFloat(item.qty) || 0
            const price = parseFloat(item.price) || 0
            const lineTotal = qty * price
            costOfGoods += lineTotal
            rows.push([
                item.desc || '',
                qty,
                fmt(price),
                fmt(lineTotal),
                categoriseItem(item),
                item.ac_id != null ? item.ac_id : '',
                item.fc_id != null ? item.fc_id : '',
                noteFor(item)
            ])
        })
        rows.push([])
        rows.push(['', '', 'Cost of Goods (ex VAT)', fmt(costOfGoods)])
        rows.push([])

        // ---------- Customer Price Build-up ----------
        // sellprice = ((nc - additional_discount) * (1 + vat/100)) - shared_discount,
        // where nc = getOfferSystemCost(offerid, systemcost).
        const systemcost = parseFloat(this.state.systemcost) || 0
        const offerid = this.state.offerid || ''
        const offerDiscount = parseFloat(this.GetOfferDiscount(offerid)) || 0
        const ncAfterOffer = parseFloat(this.getOfferSystemCost(offerid, systemcost)) || 0
        const additionalDiscount = parseFloat(this.state.additional_discount) || 0
        const vatRate = parseFloat(this.state.vat) || 0
        const sharedDiscount = parseFloat(this.state.shared_discount) || 0
        const ncAfterDiscount = ncAfterOffer - additionalDiscount
        const vatAmount = ncAfterDiscount * (vatRate / 100)
        const subtotalIncVat = ncAfterDiscount + vatAmount
        const customerPrice = subtotalIncVat - sharedDiscount

        rows.push(['Customer Price Build-up'])
        rows.push(['Detail', 'Amount (£)'])
        rows.push(['System Base Price (ex VAT)', fmt(systemcost)])
        rows.push([`Offer applied: ${offerid}`, `(saves ${fmt(offerDiscount)})`])
        rows.push(['Net Cost after Offer (ex VAT)', fmt(ncAfterOffer)])
        rows.push(['Additional Discount', `-${fmt(additionalDiscount)}`])
        rows.push(['Net Cost after Discounts (ex VAT)', fmt(ncAfterDiscount)])
        rows.push([`VAT (${vatRate}%)`, fmt(vatAmount)])
        rows.push(['Subtotal (inc VAT)', fmt(subtotalIncVat)])
        rows.push(['Shared Discount (WOS / Rep)', `-${fmt(sharedDiscount)}`])
        rows.push(['Customer Price', fmt(customerPrice)])
        rows.push([])

        // ---------- MT Solar Margin ----------
        // commission = (net_cost - additional_discount) * commperc/100
        // total_commission = commission + (selfgen?300:0) - comm_sacrifice - (commperc * 7)
        // (the 7 comes from pdf_config WOS fixed-cost comms deduction per percentage point)
        const commPerc = parseFloat(this.state.commperc) || 0
        const commSacrifice = parseFloat(this.state.comm_sacrifice) || 0
        const selfGenBonus = this.state.selfgen ? cfg('selfgen_bonus', 300) : 0
        const commission = (ncAfterDiscount) * (commPerc / 100)
        const wosFixed = commPerc * cfg('wos_fixed_deduction_per_pct', 7)
        const totalCommission = commission + selfGenBonus - commSacrifice - wosFixed
        const customerPriceExVat = customerPrice - vatAmount
        const grossMargin = customerPriceExVat - costOfGoods
        const netToCompany = grossMargin - totalCommission

        rows.push(['MT Solar Margin'])
        rows.push(['Detail', 'Amount (£)'])
        rows.push(['Customer Price (inc VAT)', fmt(customerPrice)])
        rows.push(['Customer Price (ex VAT)', fmt(customerPriceExVat)])
        rows.push(['Cost of Goods (ex VAT)', fmt(costOfGoods)])
        rows.push(['Gross Margin', fmt(grossMargin)])
        rows.push([`Commission @ ${commPerc}% of net`, fmt(commission)])
        rows.push(['Self-Gen Bonus', fmt(selfGenBonus)])
        rows.push(['Comm Sacrifice', `-${fmt(commSacrifice)}`])
        rows.push(['WOS Fixed Comms Deduction', `-${fmt(wosFixed)}`])
        rows.push(['Total Commission', fmt(totalCommission)])
        rows.push(['Net to MT Solar', fmt(netToCompany)])

        // UTF-8 BOM so Excel renders £, en/em-dashes correctly.
        const csv = '﻿' + rows.map(r => r.map(csvEscape).join(',')).join('\n')

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        const today = new Date().toISOString().slice(0, 10)
        a.href = url
        a.download = `job-sheet-${this.state.flg_id || 'quote'}-${today}.csv`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
    }

    // If Total Panel Output is > Total Allowed (as set by limitersize in pdf_config) a Limiter device needs to be fitted.
    isLimmiterRequired = () => {
        let totkw = 0;
        let limiterRequired = 0;
        if(this.state.batteryonly == true) {
            this.setState({limiterRequired})
            return
        }
        const proppanlength = this.props.panelArrays.length;
        for( let i=0; i<proppanlength; i++) {
            const item = this.props.panelArrays[i]
            let numPanels = !isNaN(parseInt(item.numPanels)) ? parseInt(item.numPanels) : 0
            let watts = !isNaN(parseInt(item.watts)) ? parseInt(item.watts) : 0
            console_log(`numPanels = ${numPanels} ${item.numPanels} watts = ${watts} ${item.watts} `)
            totkw += (numPanels * watts) 
        }
        console_log(`totkw ${totkw} limiter cutoff ${pdfc.limitersize}`)
        if(totkw > pdfc.limitersize)  limiterRequired = 1;
        this.setState({limiterRequired})
    }

    isEmpty = (obj) => {
        try {
            if (obj == null) return true;
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;
            if (typeof obj !== "object") return true;
            if (typeof obj === "undefined" ) return true;
            for (var key in obj) if (hasOwnProperty.call(obj, key)) return false;
            return true;
        } catch(err){ 
            return false 
        }
    }

    // Create Title case text - Eg first Char is Upper then the rest is lower.
    titleCase = (strIn) => {
        if(strIn == "" || typeof strIn == "undefined" || !strIn) return strIn
        let word = `${strIn.substring(0,1).toUpperCase()}${strIn.substring(1).toLowerCase()}`
        return word;
    }

    interimSaveState = async (st) => {
        return this.setState({...st});
    }

    APICalcSavings = async () => {
        var systemcost
        let addition_scaff = 1;
        lineitems = []
        checklist = []
        let deposit_amount = Number.parseFloat(this.props.deposit_amount??0,2).toFixed(2)
        //("System cost set to " + this.state.systemcost)
        if( this.state.elecconsumption<=0 ) {
            this.setState( 
                { 
                    errTitle: "Error Electricity Consumption",
                    errText: "You MUST Enter a Value for Electric Consumption before you can calculate",
                    errOpen: true 
                })
            
        }
        if( this.props.elecrate == null || typeof this.props.elecrate == "undefined" || this.props.elecrate<=0) {
            this.setState( { 
                errTitle: "Error Electricity Rate",
                errText: "You MUST Enter a Value for Electricity Rate before you can calculate",
                errOpen: true, })
            return;
        }
        if(this.isEmpty(this.state.selected_tariff)  ) {
            this.setState( { 
                errTitle: "Error no Tarrif Selected",
                errText: "You MUST Select A New Energy Tariff before you can calculate",
                errOpen: true, })
            return;

        }
        if(typeof this.state.offerid == "undefined" || this.state.offerid == "") {

            this.setState( { 
                errTitle: "Error Self Consumption",
                errText: "You MUST Select An Offer (Next to Sale Type) before you can calculate",
                errOpen: true, })
            return;            
        }

        if(this.state.systemcost <= 0 || this.state.systemcost == "" || this.state.sellprice <=0 || this.state.sellprice == "" ) {
            this.setState( { 
                errTitle: "Error System Cost",
                errText: "You MUST Enter a Value for the Cost of the System or a Value Greater than the minimum Price allowed before you can calculate",
                errOpen: true, })
            return;
        }

        if(this.state.selfconsumption == "") {
            this.setState( { 
                errTitle: "Error Self Consumption",
                errText: "You MUST Select the Self Consumption on the Energy Tab before you can calculate",
                errOpen: true, })
            return;            
        }

        var sc = typeof this.state.systemcost !== "undefined" ? this.state.systemcost : 0;
        if(this.state.dont_update_base && (this.state.hold_base_price??0) > 0 )
            sc =  this.state.hold_base_price 
        let finance_charge = 0 // this.state.finance_charge
        if(!finance_charge || typeof finance_charge == "undefined" || finance_charge == null) finance_charge = 0
        systemcost = this.getOfferSystemCost(this.state.offerid, sc) + finance_charge;
        let baseprice = this.state.systemcost 
        if(this.state.dont_update_base && (this.state.hold_base_price??0)> 0)
            baseprice = this.state.hold_base_price

        let vat = this.GetVatRate()
        let sellprice = this.getSellPrice()

        this.isLimmiterRequired();
        await this.interimSaveState({calculating: true, show_agreement: false})
        //this.setState({calculating: true, show_agreement: false});
        const {savings,slides, postcode } = this.state
        const payload = {
            flg_id:                 this.state.flg_id,
            financeOptions:         this.state.financeOptions,
            token:                  this.state.token,
            postcode:               postcode ? postcode.toUpperCase() : '',
            elecrate:               this.props.elecrate,
            elecconsumption:        this.state.elecconsumption,
            selected_tariff:        this.state.selected_tariff,     // New Smart Energy  Tariff
            elec_annual_increase:   this.state.elec_annual_increase,
            gasconsumption:         this.state.gasconsumption,
            gasrate:                this.state.gasrate,
            vo:                     this.state.vo,
            selfconsumption:        this.state.selfconsumption,
            panelArrays:            this.props.panelArrays && this.props.panelArrays.length > 0 ? JSON.parse(JSON.stringify(this.props.panelArrays)) : [],
            savings:                savings && savings.length > 0 ? JSON.parse(JSON.stringify(savings)) : [],
            systemcost:             systemcost ? systemcost : 10000,
            selectedFinance:        this.state.selectedFinance,
            financeoption:          this.state.financeoption,
            financeTerm:            this.state.selectedFinanceTerm+1,
            battery:                this.state.battery,
            has_voltageoptimser:    this.state.has_voltageoptimser,
            has_iboost:             this.state.has_iboost,
            has_smart_thermostat:   this.state.has_smart_thermostat,
            has_smart_energy:       false, // this.state.has_smart_energy,
            has_boiler_manager:     this.state.has_boiler_manager,
            deposit_amount:         deposit_amount,
            dont_update_base:       this.state.dont_update_base,
            hold_base_price:        this.state.hold_base_price,
            shared_discount:        this.state.shared_discount??0.00, 
        }
        let ret = {errOpen: false, calculating: false}
        let result = await getSolarSavigsFromServer(payload,'CalcSolar')
 
        if(result.status) {
            var i = 0
            //while(this.state.calculating && this.state.savings !== result.savings && i < 10) {               
            //    i++;
            //    await this.sleep(500);
            //}

            //this.setState({...result})
            await this.interimSaveState(result)
            let average_monthly_loan = (result.savings[0]?.annual_loan_cost??0)/12
            average_monthly_loan = result.monthly_loan_payment ?? average_monthly_loan
            average_monthly_loan = (average_monthly_loan ?? 0).toFixed(3)
            this.props.updatefinmonthlypayment(average_monthly_loan??0.00)

            let ft = this.state.selectedFinanceTerm??0
            if(ft > 0 ) ft=ft+1
            let tot_annual_loan_cost = this.state.totals.tot_annual_loan_cost??0.00
            if(tot_annual_loan_cost== '') tot_annual_loan_cost=0.00
            let total_cost_with_loan = tot_annual_loan_cost.toFixed(2)
            this.props.updatefintotalcost(total_cost_with_loan)
            
            // Update required inverters and get a copy of the inverters required
            let required_inverters = []
            let ret = await this.GetRequiredInverters()
            if(ret.errOpen) 
                return  this.setState({calculations_run: true, required_inverters, errOpen: ret.errOpen,   errText: ret.errText, errTitle: ret.errTitle, vat, calculating: false, merge_completed: true }) //calculations_run: true            
            required_inverters= ret.required_inverters??null
            this.setState({required_inverters}, () => {
                this.updateParent()
            })
            // Update the Parent and force a Database update / save
            await this.updateParent()
            // Create the set of Line Items that will be dispayed.
            await this.createLineItems(required_inverters)

            // await this.processPDFPages()
            const {selectedFinanceTerm, financeoption, selected_maintenance,filelist, offerid } = this.state

            // Create the rest of our line items so we can work out the prices
            // And Output thedata for auditing.
            await this.CreateAdditionLinesFromAncillayItems(required_inverters)

            // Do our calcs to work out sales price and with dscounts etc
            let net_cost =0;
            //console.log(lineitems)
            lineitems.map((item)=> {
                //console.log(item)
                net_cost += ((item.price??0) * (item.qty??0));  
                // console.log(`${item.desc} nc: ${net_cost}, ip: ${item.price}, iq: ${item.qty}`)
            })
            net_cost=parseInt((net_cost??0) * pdfc.markup_rate)

            // If we have overridden the Sell Price.                      
            if(this.state.dont_update_base) {
                net_cost =   this.getOfferSystemCost(this.state.offerid ,this.state.hold_base_price)      
            }
            let offer_discount = this.GetOfferDiscount(this.state.offerid)
            let base_price =   net_cost + offer_discount    

            let additional_discount = pdfc.phone_discount - this.GetOfferDiscount(this.state.offerid)
            // console.log(`bp: ${base_price}, net_cost ${net_cost}, od: ${offer_discount}, ad: ${additional_discount}`)
            
            if(this.state.dont_update_base)  {
                if((this.state.hold_base_price??0)> 0 ) {
                    base_price = this.state.hold_base_price
                    this.updateSystemCost(this.state.hold_base_price)
                }
            }
            vat = this.GetVatRate()
            
            //await this.processPDFPages()
            //lineitems.push({desc: "Scaffolding Costs",qty: addition_scaff, price: pdf_config.scaff_perside})
            sellprice =  this.getSellPrice(base_price)

            let utime = Date.now()
            this.setState({net_cost, sellprice, additional_discount, lineitems, finance_charge, vat, base_price,baseprice: base_price, systemcost: base_price, addition_scaff, calculations_run: true, required_inverters}, 
                async () => { 
                    //console.log(`about call updateParent sellprice set to ${sellprice}`)
                    await this.updateParent();
                    await this.processPDFPages()
                })

        }
        else {
            console_log("ERROR: In APICalcResults. returned...")
            console_log(result)
            console_log(payload)
            this.setState({
                calculations_run: false,
                calculating: false,
                savings: null,
                errOpen: true,
                errTitle: 'Error Calculatig Saving',
                errText: 'The following error occured<br/>' + result.error +'<br/>Try again to see if the error is fixed or report to IT Support.' ,
            })
        }

    }

    CreateAdditionLinesFromAncillayItems = async (required_inverters) => {
        // Get All the line items we need but the qty data comes ftom Inputs rather than the DB so we dont want to display on the costings
        ancillarycosts.filter((item) => item.skip == true ).map((item) => {
            let process = true
            if(this.state.batteryonly && item.battery_only == false)
                process = false

            if(process) {
                let qty = typeof this.state[item.fieldvar] !== "undefined" ? this.state[item.fieldvar] : 0
            
                // Check if a Battery Only Install and Eddi is being added.
                if(this.state.batteryonly && item.code=='eddi' && item.ac_id==175 && item.qty > 0) {
                    const edextra = ancillarycosts.find(item => (item.ac_id=1200 && item.code =='eddi-battery-install'))
                    if(edextra) {
                        lineitems.push({desc: 'Battery Only Install with Eddi', qty: 1, price: edextra.item_cost, ac_id: edextra.ac_id})           
                        checklist.push({desc: 'Battery Only with Eddi', count: 1 })                   
                    }
                }
                if(item.input_field && item.fieldvar > "") {
                    const fi = this.FindAI(item.fieldvar)
                    if(fi) qty = fi.value
                    //qty = typeof this.state.ancillary_items[item.fieldvar] !== "undefined" ? this.state.ancillary_items[item.fieldvar] : 0
                }  
                // Dont Add a SOFAR Inverter Warranty if we dont have any SOFAR Inverters. 
                let add_item = true 
                if(item.code == "sofar10wrnty") {
                    add_item = this.CheckInSOFARInverter(required_inverters)
                }
                //if(item.code =='scafps')    // Additional scaff side
                //    addition_scaff+=qty
                
                if(add_item == true)
                    lineitems.push({desc: item.description,qty , price: item.item_cost, skip: true, ac_id: item.ac_id})
            }
        })  
        // Add delivery Miles if not a Battery only job
        if(this.state.batteryonly == false)
            checklist.push({desc: 'Delivery Miles', count: this.state.delivery_miles})
    
        // Get Number of panels
        const pa = this.props.panelArrays
        let qty_panels = 0
    
        if(typeof pa !== "undefined" && pa.length > 0) {
            pa.map(item=> {
                if(!isNaN(parseInt(item.numPanels))) 
                    qty_panels +=parseInt(item.numPanels)
            })
        }
        if((this.state.batteryonly??false))
            qty_panels = 0 

        // Get all of our Line Items where we do want to display on the System
        ancillarycosts.filter((item) => item.skip !== true ).map((item) => {
            let process = true
            if(this.state.batteryonly && item.battery_only == false)
                process = false

            if( process ) {

                if(item.fieldvar == "") {
                    
                    // Cater for > 16 Panels additional Ancillaries per every 16
                    if(item.code== "elecanc" && qty_panels > 16) {
                        const anc_qty = item.item_qty + parseInt(qty_panels/16)
                        lineitems.push({desc: item.description,qty: anc_qty, price: item.item_cost, skip: false, ac_id: item.ac_id})
                    }else
                        lineitems.push({desc: item.description,qty: item.item_qty, price: item.item_cost, skip: false, ac_id: item.ac_id})
                } else {

                    let qty = 0
                    if (item.code === "lanscape") {
                        // Landscape panel qty is derived from layoutSets, not a manual entry.
                        qty = this.getLandscapePanelCount()
                    } else {
                        const fi = this.FindAI(item.fieldvar)
                        if(item.input_field)
                            qty = fi ? fi.value : 0
                        else
                            qty = typeof(this.state[item.fieldvar]) !== "undefined" ? this.state[item.fieldvar] : 0
                    }
                    console_log(`item.fieldvar = ${item.fieldvar} value = ${this.state.ancillary_items[item.fieldvar]} qty=${qty} `)
                    lineitems.push({desc: item.description,qty: qty, price: item.item_cost, skip: false, ac_id: item.ac_id})
                }
            }
        })

        if(this.state.batteryonly == true) {
            fixedcosts.map((item,index) =>{
                if(item.ignore_if_batteryonly == false)
                    lineitems.push({desc: item.description,qty: item.item_qty, price: item.item_cost, fc_id: item.fc_id})
            }); 
        }else {
            fixedcosts.map((item,index) =>{
                if(item.ignore_if_nonbatteryonly == false)
                    lineitems.push({desc: item.description,qty: item.item_qty, price: item.item_cost, fc_id: item.fc_id})
            }); 
        }

        // If we are on a battery only install and an iBoost is added we need to charge for extra electrical equipment and labour
        if(this.state.batteryonly && this.state.has_iboost) {
            const edextra = ancillarycosts.find(item => (item.ac_id===1300 && item.code ==='iboost-battery-install' ))
            if(edextra) {
                lineitems.push({desc: 'Battery Only Install with iBoost', qty: 1, price: edextra.item_cost, ac_id: edextra.ac_id})           
                checklist.push({desc: 'Battery Only with iBoost', count: 1 })                   
            }
        }


    }
    // Get the Required Inverters take into account battery only and errors
    GetRequiredInverters = async () => {
        let ret = {}
        let required_inverters = []
        try {
            let invbad = false;
            if(this.state.batteryonly == false) {
                ret = await CalcInverters(this.state.required_inverters, this.state.battery, this.props.panelArrays, this.state.offerid, this.props.is3phase,  this.props.offgrid)
                if(ret && typeof ret !== "undefined" && ret.status) {
                    const retinvlength = ret.required_inverters.length
                    for(let i=0; i<retinvlength; i++)
                        if(typeof ret.required_inverters[i].inverter.id == "undefined") {
                            invbad = true;
                        }
                }else {
                    invbad = true;
                }
                ret.calculating = false
                if(invbad) {
                    ret.errText =  `One or more Inverter Type could not be Calculated. Please Check Inverters and Select manually`
                    ret.errOpen = true
                    ret.errTitle = "Error Calculating Inverter Type. Check Inveters!!"
                }else {
                    ret.errText = '' 
                    ret.errOpen = false
                    ret.errTitle =''
                }
            }else {
                required_inverters = JSON.parse(JSON.stringify(this.state.required_inverters))
                ret.required_inverters = required_inverters
                ret.errOpen = false
                ret.errTitle = ''
                ret.errText = ''
            }
        }catch(e) {
            console.log("Exception hit")
            console.log(e)
            if(typeof ret == "undefined") {
                ret = {
                    calculating: false, 
                    errOpen: true, 
                    errTitle: 'Error Calculating Inverter Type. Check Inveters!!',
                    errText: `An error occured whilst calculating the Inverter type! Please Check Inverters and check if they need to be manually selecteced ${e}`
                }
            }else {
                ret.calculating = false
                ret.errOpen = true
                ret.errTitle = 'Error Calculating Inverter Type. Check Inveters!!'
                ret.errText =  `An error occured whilst calculating the Inverter type! Please Check Inverters and check if they need to be manually selecteced ${e}` 
            }
        }         
        return ret
    }

    GetVatRate = () => {
        var vat = pdfc.vat_rate
        if((this.state.batteryonly??false) == true) 
            vat = pdfc.commercial_vat_rate
        else if((this.props.propertytype??'') == 'Commercial')
                vat = pdfc.commercial_vat_rate
        return vat 
    }

    // Calculate the final Sell Price to the customer
    getSellPrice =  (sc = null) => {
        // Get Base Price / Systecost
        let systemcost = this.state.systemcost
        if(sc)
            systemcost = sc // Use supplied System cost when we have it
        if(this.state.dont_update_base) {
            systemcost =   this.state.hold_base_price      
        }

        // Calculate any addition discount (Before VAT)
        let offerid = this.state.offerid
        let offer_discount = this.GetOfferDiscount(offerid)
        let additional_discount = pdfc.phone_discount - (offer_discount ?? pdfc.phone_discount)

        // Get the current VAT Rate - Take into account Commerical and Battery Only do no have
        // Special VAT Treatments
        let vat = this.GetVatRate()

        // Get the Nett Price 
        let nc = this.getOfferSystemCost(offerid, systemcost)
        nc = nc??0
        // Now calulcate Sell Price
        // Nett Cost - any Addition Discounts
        // ADD VAT
        // Then subtract any Shared Discount.

        let sellprice = ((nc - additional_discount) * (1+ (vat/100))) - (this.state.shared_discount??0) 
        return sellprice        
    }


    CheckInSOFARInverter = (required_inverters) => {
        let issofar = false
        if(typeof required_inverters == "undefined"  ) return false
        const invlength = required_inverters.length;
        for(let iv=0; iv<invlength; iv++) {
            const selinv = required_inverters[iv]
            if(selinv && typeof selinv!== "undefined" && selinv.inverter && typeof selinv.inverter !== "undefined" ) {
                if(selinv.inverter.manufacturer == "SOFAR") {
                    issofar = true
                    break
                }
            }else {
                console.log(`Count not find inverter manufacturer for inverter ${iv}`)
                console.log(selinv)
            }
        }
        return issofar
    }
    // Find an Ancillary Item or  return null
    FindAI = (item) => {
        if(typeof this.state.ancillary_items== "undefined") return null;
        const found = this.state.ancillary_items.find((x) => x.key == item)
        if(typeof found !== "undefined") return found
        return null
    }

    // Count panels marked as landscape across every array's layoutSets.
    // Used to auto-price ancillary ac_id 100 (Landscape Mounted Panels) instead of
    // relying on a manual entry on the Price tab.
    getLandscapePanelCount = () => {
        const arrays = this.props.panelArrays || []
        let total = 0
        for (const arr of arrays) {
            const sets = arr.layoutSets || []
            for (const set of sets) {
                if (set.panelOrientation === 'landscape') {
                    const rows = set.rows || []
                    for (const r of rows) total += (parseInt(r) || 0)
                }
            }
        }
        return total
    }

    outputPricing = async (commission) => {

        //var ancillarycosts = []
        //var fixedcosts = []
        let offer_discount = this.GetOfferDiscount(this.state.offerid)
        let additional_discount = pdfc.phone_discount - (offer_discount ?? pdfc.phone_discount)
        if(!this.state.component_mounted) {
            return;
        }
        if(typeof lineitems === "undefined" || lineitems.length == 0) return

        const offerid = this.state.offerid
        let net_cost =0;
        let pricing_out = []
        //console_log("**** CALC PRICING ****")
        lineitems.map((item)=> {
            item.qty = item.qty??0
            item.price = item.price??0
            pricing_out.push(item)
            net_cost += ((item.price??0) * (item.qty??0));  
            // console.log(`PRICE: ${item.desc} ${item.price} ${item.qty} ${net_cost}`)
        })

        pricing_out.push({qty: -1,desc: "",price: "", total: ""})
        pricing_out.push({qty: -1,desc: "",price: "", total: ""})
        pricing_out.push({qty: -1,desc: "Net Cost",price: net_cost, total: net_cost})

        const nomarkup_costs = net_cost
        let shared_discount = this.state.shared_discount??0
        net_cost=((net_cost??0) * (pdfc.markup_rate??0)).toFixed(0)
        const comms_base = (net_cost - shared_discount)
        pricing_out.push({qty: -1,desc: "Net Cost With Markup",price: net_cost, total: net_cost})
        const vat =  this.GetVatRate()      
        

 
 
        const withvat = (net_cost *(1+(vat/100))).toFixed(2);
        let vat_due = ((net_cost??0) * (vat/100)).toFixed(2)
        pricing_out.push({qty: -1,desc: `VAT @ ${vat}%`,price: vat_due, total: vat_due})
        pricing_out.push({qty: -1,desc: "Customer Price With VAT",price: withvat, total: withvat})
        var finance_charge = 0
        let sellprice = 0
        let base_price = 0
        let sd = 0

        // Use try catvh in case financeoption has not yet been initiated
        try { 
            finance_charge = 0 // parseInt(withvat * (this.state.financeoption.finance_charge  / 100))
        }catch(err ) {
            finance_charge = 0
        }

        if(finance_charge > 0)
        {
            finance_charge = 0
            // finance_charge = parseInt(withvat * (this.state.financeoption.finance_charge  / 100))
            pricing_out.push({qty: -1,desc: `Extra Admin Fee `,price: finance_charge, total: finance_charge})
            var cpwpfin = parseInt( (net_cost * (1+ (vat/100)) ) + finance_charge) 
            pricing_out.push({qty: -1,desc: "VAT",price: vat_due, total: vat_due})
            pricing_out.push({qty: -1,desc: "Customer Price With VAT & Extra Admin Fees",price: cpwpfin, total: cpwpfin})

            base_price = parseInt(withvat + offer_discount + finance_charge) 
            pricing_out.push({qty: -1,desc: "Base Price With VAT & Extra Admin Fee",price: base_price, total: base_price})
    
            net_cost = this.getOfferSystemCost(offerid, (base_price-finance_charge)) 
            //if(this.state.batteryonly == false)
            //   additional_discount = parseInt( (net_cost * (1+(vat/100))) - (net_cost ) )
            pricing_out.push({qty: -1,desc: "Warranty Discounts",price: additional_discount, total: additional_discount})
            

            sd = this.state.shared_discount??0
            net_cost = this.getOfferSystemCost(offerid, base_price)
            sellprice = this.getSellPrice() 

            pricing_out.push({qty: -1,desc: "Shared Comm Discounts",price: sd, total: sd})
    
            pricing_out.push({qty: -1,desc: "Customer Final Price Less Shared Comms & Admin Fee",price: (net_cost-sd), total: (net_cost-sd)})
        }
        else {
            finance_charge = 0 
            base_price = parseInt( withvat + offer_discount)
            pricing_out.push({qty: -1,desc: "Base Price With VAT",price: base_price, total: base_price})
    
            net_cost = this.getOfferSystemCost(offerid, base_price)

            sellprice = this.getSellPrice()
            //if(this.state.batteryonly == false)
                // additional_discount = parseInt( (net_cost * (1+(vat/100))) - (net_cost ) )
            pricing_out.push({qty: -1,desc: "Warranty Discounts",price: additional_discount, total: additional_discount})
    
            sd = this.state.shared_discount??0
            pricing_out.push({qty: -1,desc: "Shared Comm Discounts",price: sd, total: sd})
    
            pricing_out.push({qty: -1,desc: "Customer Final Price with VAT Less Shared Comms",price: sellprice, total: sellprice})
    
        }


        const commrate = this.state.commperc
        const commperc = (commrate / 100)
        const basecoms = comms_base * commperc
        const maxcoms = comms_base * 0.11
        const warranty_sac = additional_discount * commperc
        const selfgen = this.state.selfgen ? cfg('selfgen_bonus', 300) : 0
        const wosfixeddeduc = commperc * cfg('wos_fixed_deduction_per_pct', 7)
        const comnsacc = sd / 2
        const totalcomms = basecoms + selfgen - warranty_sac - comnsacc - wosfixeddeduc
        const max_totalcomms = parseInt(maxcoms + selfgen - warranty_sac - comnsacc)
        const our_profit = parseInt(net_cost - nomarkup_costs - max_totalcomms)
        const rep_name = this.state.rep_name??''
        

        pricing_out.push({qty: -1,desc: "",price: "", total: ""})
        pricing_out.push({qty: -1,desc: "",price: "", total: ""})
        
        pricing_out.push({qty: -1,desc: "Rep Base Commission ",price: basecoms, total: basecoms})
        pricing_out.push({qty: -1,desc: "WOS Fixed Cost Comms Deduction ",price: commperc * cfg('wos_fixed_deduction_per_pct', 7), total: basecoms})
        
        pricing_out.push({qty: -1,desc: "Self Gen Commission ",price: selfgen, total: selfgen})
        pricing_out.push({qty: -1,desc: "Less Warranty Commission ",price: warranty_sac, total: warranty_sac})
        pricing_out.push({qty: -1,desc: "Less Shared Discount Commission Sacrifice",price: comnsacc, total: comnsacc})
        pricing_out.push({qty: -1,desc: "Final Commission ",price: totalcomms, total: totalcomms})
        pricing_out.push({qty: -1,desc: "WOS", price: our_profit, total: our_profit})
        pricing_out.push({qty: -1,desc: "CHECKDIGITS", price: max_totalcomms, total: max_totalcomms})
        if(this.state.sweep_sale) {
            pricing_out.push({qty: -1,desc: "Sale Has Been Swept ",price: "", total: ""})
            pricing_out.push({qty: -1,desc: `Manager -  ${rep_name}`,price: pdfc.manager_sweep_commission, total: ""})
            pricing_out.push({qty: -1,desc: `Rep -  ${this.props.assigned_rep}`,price: pdfc.rep_sweep_commission, total: ""})
        }else
            pricing_out.push({qty: -1,desc: "Sale Not Swept ",price: "", total: ""})

        
        // console.log('Pricing Out')
        // console.log(pricing_out);
        if(JSON.stringify(this.state.pricing_out) == JSON.stringify(pricing_out) ) {
            return;
        }
        await APIOutputPricing(this.state.flg_id, pricing_out, this.state.full_name, this.state.address)

        this.setState({pricing_out: JSON.parse(JSON.stringify(pricing_out))})
    }



    getOfferSystemCost = (offerid,baseprice ) => {
        var systemcost = 0
        var shared_discount = typeof this.state !== "undefined" ? this.state.shared_discount : 0
        let offer = offerid
        if(typeof this.state !== "undefined" && this.state.batteryonly == true) {
            offer = '7 Day Offer 5'
            //this.setState({offerid: offer})
        }

        switch(offer ) {
            case '(30) Everyday':
                systemcost = typeof this.state !== "undefined" ? (this.state.systemcost ) : 0;
                break;
            case 'Privileged':
                systemcost = (baseprice - pdfc.priv_discount )
                break;
            case '7 Day Offer 1':
                systemcost = (baseprice - pdfc.phone_discount)
                break;
            case '7 Day Offer 2':
                systemcost = (baseprice - pdfc.phone_discount )      
                break;
            case '7 Day Offer 3':
                    systemcost = (baseprice - pdfc.phone_discount - pdfc.phone_discount_offer3 )
                    break;
            case '7 Day Offer 5':
                systemcost = (baseprice - pdfc.phone_discount )
                break;
        }
        return systemcost
    } 


    GetOfferDiscount = (offerid) => {

        let offer = offerid
        if(typeof this.state !== "undefined" && this.state.batteryonly == true) {
            offer = '7 Day Offer 5'
            //this.setState({offerid: offer})
        }
        let discount = 0 
        switch(offer ) {
            case '(30) Everyday':
                discount = 0;
                break;
            case 'Privileged':
                discount = pdfc.priv_discount 
                break;
            case '7 Day Offer 1':
                discount = pdfc.phone_discount
                break;
            case '7 Day Offer 2':
                discount = pdfc.phone_discount       
                break;
            case '7 Day Offer 3':
                discount = pdfc.phone_discount - pdfc.phone_discount_offer3 
                    break;
            case '7 Day Offer 5':
                discount = pdfc.phone_discount 
                break;
        }
        return discount
    } 
    // Validate the mpan Number
    ValidateMPAN = (mpan) => {
        if(typeof mpan == "undefined") return false
        if(isNaN(mpan)) return false
        if(mpan.length < 13) return false
        var primes = [3,5,7, 13, 17, 19, 23, 29, 31, 37, 41, 43]
        var checkdigit = parseInt(mpan.toString().substring(12,13))
    
        let tot = 0
        const primelenth = primes.length;
        for(let i=0; i<primelenth; i++) {
            let vl = parseInt(mpan.toString().substring(i,i+1))
            let prm = primes[i]
            tot+=( parseInt(mpan.toString().substring(i,i+1)) * primes[i]  )
        }
        let mod11 = (tot % 11) // - parseInt(tot/11)
        let mod10 = mod11 % 10
        return (checkdigit == mod10)
    }
    
    summaryPanelFixings = (panelArrays) => {
        let instcounts = []
        let numarrays = panelArrays ? panelArrays.length : 0
        for(let ip = 0;  ip<numarrays ; ip++) {
            const insttype = panelArrays[ip].installation_location
            const installation_id = isNaN(panelArrays[ip].installation_location.installation_id)?-1:parseInt(panelArrays[ip].installation_location.installation_id)
            if((insttype??null)) {
                let instfound = instcounts.find( (inst) => inst.installation_id == installation_id)
                let instfoundindex = instcounts.findIndex((inst) => inst.installation_id == installation_id)
                let inumPanels =  panelArrays[ip].numPanels
                inumPanels = isNaN(inumPanels)?0:parseInt(inumPanels)
                if(instfound)
                    instcounts[instfoundindex].count += inumPanels
                else
                    if(installation_id > 0)
                        instcounts.push({desc: `Panel Fixing: ${insttype.description??'N/A'}`, count: inumPanels,installation_id})
                    else
                        instcounts.push({desc: `Panel Fixing: Standard Roof`, count: inumPanels, installation_id})
            }
        }
        return instcounts??[]
    }

    // Calculate totals for rails, hooks, clamps, and end stops from all panel arrays
    calculateRailsHooksTotals = (panelArrays) => {
        const emptyColour = () => ({ rails: 0, clamps: 0, endStops: 0, splice: 0, totalRailLengthM: 0 })
        const byColour = { silver: emptyColour(), black: emptyColour() }
        const hooksByInstallation = {}

        if (!panelArrays || panelArrays.length === 0) {
            return { rails: 0, clamps: 0, hooks: 0, endStops: 0, splices: 0, byColour, hooksByInstallation }
        }

        // Rail piece length per colour comes from the mounting_hardware_map.
        // Falls back to 3.6m if no slot is configured (current Clenergy spec).
        const railLengthForColour = (colour) => {
            const slot = (mountingHardwareMap || []).find(s => s.section === colour && s.slot_type === 'rail')
            const len = parseFloat(slot && slot.length_m)
            return (Number.isFinite(len) && len > 0) ? len : 3.6
        }

        let totalRails = 0
        let totalClamps = 0
        let totalHooks = 0
        let totalEndStops = 0
        let totalSplices = 0

        panelArrays.forEach(panelArray => {
            const layoutSets = panelArray.layoutSets || []
            // Per-array colour choice — Silver is the default (Black has long lead times).
            const colour = panelArray.railColour === 'black' ? 'black' : 'silver'
            const installation_id = parseInt(panelArray.installation_location?.installation_id) || 0
            const railLen = railLengthForColour(colour)

            let arrayClamps = 0
            let arrayEndStops = 0
            let arrayRailLengthM = 0
            let arrayHooks = 0
            let arrayRails = 0
            let arraySplices = 0

            layoutSets.forEach(set => {
                if (!set.rows || set.rows.length === 0) return

                const railsPerRow = 2 // top and bottom rail per row
                const hookSpacing = 1.2 // metres
                const panelDimensions = {
                    width_mm: panelArray.width_mm || 1134,
                    height_mm: panelArray.height_mm || 1722
                }
                const panelSize = set.panelOrientation === 'portrait'
                    ? (panelDimensions.width_mm || 1134) / 1000
                    : (panelDimensions.height_mm || 1722) / 1000

                let setRailLength = 0
                set.rows.forEach(panelsInRow => {
                    const rowRailLength = panelsInRow * panelSize
                    setRailLength += rowRailLength * 2 // top + bottom rail per row
                    arrayClamps += (panelsInRow * 2) + 2 // (N × 2) + 2 per row

                    // Pieces per rail in this row. If row length exceeds rail length, we need
                    // multiple rail pieces joined with rail joiners (splices). One joiner per join,
                    // i.e. (pieces - 1) per rail. railsPerRow rails (top + bottom) per row.
                    if (rowRailLength > 0 && railLen > 0) {
                        const piecesPerRail = Math.ceil(rowRailLength / railLen)
                        arrayRails += piecesPerRail * railsPerRow
                        arraySplices += Math.max(0, piecesPerRail - 1) * railsPerRow
                    }
                })

                const totalRailsInSet = set.rowCount * railsPerRow
                const avgRailLength = totalRailsInSet > 0 ? setRailLength / totalRailsInSet : 0
                const hooksPerRail = avgRailLength > 0 ? Math.ceil(avgRailLength / hookSpacing) + 1 : 0
                arrayHooks += hooksPerRail * totalRailsInSet
                arrayEndStops += totalRailsInSet * 2
                arrayRailLengthM += setRailLength
            })

            byColour[colour].rails += arrayRails
            byColour[colour].clamps += arrayClamps
            byColour[colour].endStops += arrayEndStops
            byColour[colour].splice += arraySplices
            byColour[colour].totalRailLengthM += arrayRailLengthM

            hooksByInstallation[installation_id] = (hooksByInstallation[installation_id] || 0) + arrayHooks

            totalRails += arrayRails
            totalClamps += arrayClamps
            totalHooks += arrayHooks
            totalEndStops += arrayEndStops
            totalSplices += arraySplices
        })

        return {
            rails: totalRails,
            clamps: totalClamps,
            hooks: totalHooks,
            endStops: totalEndStops,
            splices: totalSplices,
            byColour,
            hooksByInstallation
        }
    }

    // Calculate optimal rail pieces from 4m and 3m lengths
    calculateRailPieces = (totalLengthMeters) => {
        if (totalLengthMeters <= 0) return { rail4m: 0, rail3m: 0, waste: 0 }

        // Try different combinations to minimize waste
        let bestCombo = { rail4m: 0, rail3m: 0, waste: Infinity }

        // Max possible rails needed
        const maxRails = Math.ceil(totalLengthMeters / 3) + 2

        for (let num4m = 0; num4m <= maxRails; num4m++) {
            for (let num3m = 0; num3m <= maxRails; num3m++) {
                const totalAvailable = (num4m * 4) + (num3m * 3)
                if (totalAvailable >= totalLengthMeters) {
                    const waste = totalAvailable - totalLengthMeters
                    // Prefer fewer total pieces, then less waste
                    const currentTotal = num4m + num3m
                    const bestTotal = bestCombo.rail4m + bestCombo.rail3m
                    if (waste < bestCombo.waste || (waste === bestCombo.waste && currentTotal < bestTotal)) {
                        bestCombo = { rail4m: num4m, rail3m: num3m, waste: Math.round(waste * 100) / 100 }
                    }
                }
            }
        }

        return bestCombo
    }
    
    createLineItems = async (required_inverters) => {
        var ipanels = 0 
        var birdprotection_cnt = 0
        var types = []
        var lines = []
        var tg_qty = 0;
        var se_qty = 0;
        const panelArrays = this.props.panelArrays
        var paneldesc = ''
        var panelprice = 0
        var scaff_sides = 1



        // Start with our Panels

        let panlength = panelArrays.length;
        for(var i=0; i<panlength; i++) {
            const numPanels = parseInt(panelArrays[i].numPanels)
            let panelModel = panelArrays[i].panelModel
            const birdprotection = panelArrays[i].birdprotection
            let panel_id = -1
            ipanels += numPanels
            paneldesc = panelModel
            panelprice = panelArrays[i].customer_price
            birdprotection_cnt += birdprotection ? numPanels : 0

            // Get the Panel Manufacturer
            var manufacturer = panelModel
            var curp = null
            var manutotal = panelModel
            if(typeof panels !== "undefined" && panels.length > 0)
                curp = panels.find(x => x.panel_id === panelArrays[i].panel_id)
            if(curp) {
                manufacturer = curp.manufacturer
                manutotal = manufacturer + " " + curp.extrainfo + " " + curp.watts + "W"
                panelprice = curp.customer_price
                panelModel = `${curp.manufacturer} ${curp.description} `
                paneldesc = panelModel
                panel_id = curp.panel_id
            }

            var typ = types.find(x => x.panel_id === panelArrays[i].panel_id)
            if(typ) 
                typ.count+=numPanels
            else    
                types.push({panelModel: manutotal, count: numPanels, panel_id: panelArrays[i].panel_id,watts: panelArrays[i].watts })

            // types.push({panelModel: panelModel, count: numPanels })
            if(typeof panelArrays[i].optimiser !== "undefined" && panelArrays[i].optimiser.type == 'TG') tg_qty+=parseInt(panelArrays[i].qty_optimisers)
            if(typeof panelArrays[i].optimiser !== "undefined" && panelArrays[i].optimiser.type == 'SE') se_qty+=parseInt(panelArrays[i].qty_optimisers)

            const insttype = panelArrays[i].installation_location

            const extra_inst_cost = (insttype.addition_price * numPanels)??0
            if(!(this.state.batteryonly??false)) {
                if(insttype) 
                    lineitems.push({desc: `Panel Fixing: ${insttype.description?? 'N/A'}`, qty: numPanels , price:insttype.addition_price , installation_id: (insttype.id??0)})
                else 
                    lineitems.push({desc: 'Panel Fixing: No Installation Type Selected', qty: numPanels , price:0 , installation_id: -1})

                if(numPanels > 0 && (this.state.batteryonly??false) == false)
                    lineitems.push({desc: paneldesc + " - Solar Panels", qty: numPanels, price: supplierUnitCost('panels', panelArrays[i].panel_id, panelprice), panel_id: panelArrays[i].panel_id})
            }
        }
        var typestring = ''
        var totkw = 0.00
        types.map(item => {
            var kw = parseFloat( (item.count * item.watts)/1000)
            totkw += kw
            typestring += typestring ? ", " + item.count + " x " + item.panelModel   : "( " + item.count + " x " + item.panelModel  
        })
        if(typestring) typestring+=" ) = " + parseFloat(totkw).toFixed(2) + "kW"



        // Update Items for our Pricing Model
        if(this.state.batteryonly == false) {
            //lineitems.push({desc: paneldesc + " - Solar Panels", qty: ipanels, price: panelprice, panel_id: panelArrays[i].panel_id})
            checklist.push({desc: 'Panels', count: ipanels})
            // Commented out — rails/hooks/clamps/end stops are now itemised individually from layoutSets (below).
            // lineitems.push({desc: "Solar Panel ancillaries", qty: ipanels, price: 56.00, installation_id: 1000})

            if( birdprotection_cnt > 0 ) {
                lineitems.push({desc: "Bird Protection Install", qty: 1, price: 250, bird_id: 1})
                lineitems.push({desc: "Bird Protection Kit", qty: birdprotection_cnt, price: 10, bird_id: 2})
            }

            // Calculate rail, hooks, clamps, and end stops from panel layout sets.
            // Totals are split by per-array railColour and by installation_id for hooks so
            // each can be priced via the admin-curated mounting_hardware_map.
            const railsHooksTotals = this.calculateRailsHooksTotals(panelArrays)

            // Only emit a lineitem when the admin has mapped an ancillary to the slot.
            // Unmapped slots (missing in the map, or ac_id=null) are silently skipped —
            // there's no value in showing zero-priced placeholder rows.
            const pushMappedItem = (slot, qty) => {
                if (!qty || qty <= 0) return
                if (!slot || slot.ac_id == null) return
                const anc = (ancillarycosts || []).find(a => a.ac_id === slot.ac_id)
                if (!anc) return
                const price = anc.customer_price ?? anc.item_cost ?? 0
                lineitems.push({
                    desc: anc.description,
                    qty,
                    price,
                    ac_id: anc.ac_id,
                    mounting_slot: slot.slot_type || null,
                    mounting_colour: slot.colour || null,
                    installation_id: slot.installation_id || null
                })
            }

            const findSlot = (section, slot_type, installation_id) => {
                return (mountingHardwareMap || []).find(s =>
                    s.section === section &&
                    (slot_type === undefined || s.slot_type === slot_type) &&
                    (installation_id === undefined || s.installation_id === installation_id)
                )
            }

            ;['silver', 'black'].forEach(colour => {
                const c = (railsHooksTotals.byColour && railsHooksTotals.byColour[colour]) || {}
                pushMappedItem(findSlot(colour, 'rail'),      c.rails)
                pushMappedItem(findSlot(colour, 'clamp'),     c.clamps)
                pushMappedItem(findSlot(colour, 'end_stop'),  c.endStops)
                pushMappedItem(findSlot(colour, 'splice'),    c.splice)
            })

            // Hooks + flashing kit + hook stop per installation_id (roof type).
            // Flashing kit and hook stop quantities mirror the hook qty (one per mounting),
            // and are only emitted when the admin has mapped them — same skip rule as everything else.
            Object.entries(railsHooksTotals.hooksByInstallation || {}).forEach(([installIdStr, qty]) => {
                const installation_id = parseInt(installIdStr)
                pushMappedItem(findSlot('hook', 'hook',         installation_id), qty)
                pushMappedItem(findSlot('hook', 'flashing_kit', installation_id), qty)
                pushMappedItem(findSlot('hook', 'hook_stop',    installation_id), qty)
            })

            lines.push("Total of " + ipanels + " Panels " + typestring)
            // Summarise the total number of roofing installation types into an array
            var instcounts = this.summaryPanelFixings(panelArrays)
            // Output into Presentation Loving Returns and Price Checklist
            const instlength = instcounts.length;
            for(let il=0; il<instlength; il++) {
                let insttype = instcounts[il]
                let installation_id = insttype.installation_id
                if(installation_id > 0) {
                    lines.push(`${insttype.desc} x ${insttype.count}`) // Loving Returns
                    checklist.push({desc: `${insttype.desc}`, count: insttype.count}) // Price Checklist
                }
                else {
                    lines.push(`Panel Fixing: Standard Roof x ${insttype.count}`)   // Loving Retunrs
                    checklist.push({desc: 'Panel Fixing: Standard Roof', count: insttype.count}) // Price Checklist
                }
            }    
        }
        var invstring = ""
        var hybridcnt = 0
        var stringcnt = 0
        var solaredgecnt = 0
        var highvoltage = 0
        let no_inverter = true
        if(typeof required_inverters !== "undefined" && !isEmpty(required_inverters)) {
            no_inverter = false
            const invlength = required_inverters.length;
            for(var iv=0; iv<invlength; iv++) {
                const inv = required_inverters[iv]
                if(typeof inv.inverter !== "undefined" && inv.inverter.id >= 0 ) {
                    if( inv.solaredge && typeof inv.inverter !== "undefined" && inv.inverter.id !== -2)
                        solaredgecnt++
                    else if(inv.inverter.hybrid && typeof inv.inverter !== "undefined" && inv.inverter.id !== -2)
                        hybridcnt++
                    else if (typeof inv.inverter !== "undefined" && inv.inverter.id == -2 ) {
                        let ikj = 0;
                    }else 
                        stringcnt++
                
                    if(typeof inv.inverter.highvoltage !== "undefined" && inv.inverter.highvoltage == true)
                        highvoltage++
                    var desc = `${inv.inverter.manufacturer} (${inv.inverter.itemcode}) ${inv.inverter.watts}W`

                    if(inv.solaredge)
                        desc += " - Solar Edge Inverter"
                    else if(inv.inverter.hybrid) {
                        if(typeof inv.inverter.highvoltage !== "undefined" && inv.inverter.highvoltage == true)
                            desc += " - Hybrid Inverter (High Voltage)"
                        else
                            desc += " - Hybrid Inverter"
                    }
                    else
                        desc += " - String Inverter"
                    
                    if(inv.is3phase ) 
                        desc += " (3Phase)"
                    if(inv.offgrid ) 
                        desc += " (Off GRid)"
                    if(inv.inverter && typeof inv.inverter !== "undefined" && inv.inverter.id >0)
                        lineitems.push({desc, qty: 1 , price: supplierUnitCost('inverters', inv.inverter.id, inv.inverter.customer_price), id: inv.id})
                }
                if(iv == 0 && inv.inverter.id < 0 )
                    no_inverter = true
            }
        }
        if(solaredgecnt > 0 )
            invstring = solaredgecnt + " X Solaredge" 
        else if(hybridcnt>0 && !this.props.offgrid) {
            if(highvoltage > 0 )
                invstring = hybridcnt + " X High Voltage Hybrid" 
            else
                invstring = hybridcnt + " X Hybrid" 
        }
        if(hybridcnt>0 && this.props.offgrid)
            invstring = hybridcnt + " X Off Grid" 
        if(hybridcnt>0 && stringcnt > 0 && !this.props.is3phase)
            invstring = invstring + ", " + stringcnt  + " X String"
        else if(hybridcnt>0 && stringcnt > 0 && this.props.is3phase)
            invstring = invstring + ", " + stringcnt  + " X 3Phase" 
        else if(hybridcnt==0 && stringcnt > 0 && !this.props.is3phase)
           invstring = stringcnt + " X String" 
        else if( hybridcnt==0 && stringcnt > 0 &&  this.props.is3phase)
            invstring = stringcnt + " X 3Phase" 

        if(invstring > "") {
            invstring += " Solar Inverter"
            const inv = required_inverters
            if(inv && inv.length > 0 && inv[0].inverter && inv[0].inverter.id > 0)
                lines.push(invstring)
        }
        
        // Update Checklist for Inverters

        if(!no_inverter ) {
            checklist.push({desc: 'Hybrid Inverter(s)', count: hybridcnt })
            checklist.push({desc: 'String Inverter(s)', count: stringcnt })
            checklist.push({desc: 'Solar Edge Inverter(s)', count: solaredgecnt })
        }else
            checklist.push({desc: 'Inverter(s)', count: 0 })

        let battery = this.state.battery
        // Battery Warranty
        const bat = this.state.battery 
        let batfound = null
        // Find Battery data

        if(bat && typeof bat !== "undefined"){
            batfound = batterys.find((x) => x._id == bat._id)

        if(bat) {
            var unit_cost = 0

            //curp = batterys.find(x => x.battery_id === battery.battery_id)
            if(battery) {
                if(this.state.batteryonly)
                    if(batfound)
                        unit_cost = batfound.battery_only_price
                    else
                        unit_cost = battery.customer_price
                else
                    unit_cost = battery.customer_price
                //let our_battery = curp
                //our_battery.unit_cost = unit_cost
                if(batfound) {
                    try {
                        batfound.Qty = bat.Qty
                    }catch(e) {
                        batfound.Qty = 1
                    }
                    this.setState({battery: batfound })
                }
                else
                    this.setState({battery })
                //battery = our_battery
            }
            
            lines.push(`${battery.Qty} x ${battery.description} & App`)
            lineitems.push({desc: `${battery.Qty} x ${battery.description}`, qty: battery.Qty, price: supplierUnitCost('batterys', battery.battery_id, unit_cost), battery_id: battery.battery_id})
            checklist.push({desc: 'Batterys', count: battery.Qty})
        }
        else
            checklist.push({desc: 'Batterys', count: 0})
        if(this.state.batteryonly == false) {   
            if(tg_qty > 0 ) {
                lines.push(tg_qty + " x Tigo Optimisers")
                lineitems.push({desc: 'Tigo Optimisers', qty: tg_qty, price: 35, uid: 1})
            }
            else if(se_qty>0) {
                // Needed for all Solar Edge
                lines.push(se_qty + " x SolarEdge Micro Inverters")
                lines.push('1 x Solaredge 100amp CT Clamp')
                lines.push('1 x Solaredge modbus')
                lineitems.push({desc: 'Solaredge modbus ', qty: 1, price: 180, solaredge: 1})
                lineitems.push({desc: 'Solaredge Micro Inverters', qty: se_qty, price:61, uid: 2})
                lineitems.push({desc: 'Solaredge 100amp CT Clamp ', qty: 1, price: 40, solaredge: 3})

                // Differentiate for With or Without a Solar Edge Battery
                if(battery && typeof battery !== "undefined" && battery.manufacturer.toUpperCase() == "SOLAREDGE") {
                    lines.push('1 x SolarEdge Energy Net Kit')
                    lineitems.push({desc: 'SolarEdge Energy Net Kit', qty: 1, price: 60, solaredge: 4})
                }else {
                    //lines.push('1 x Solaredge AC Controller/Charger')
                    lines.push('1 x Solaredge wifi Kit')
                    //lineitems.push({desc: 'Solaredge AC Controller/Charger', qty: 1, price: 650})
                    lineitems.push({desc: 'Solaredge wifi Kit ', qty: 1, price: 60, solaredge: 5})
                }
            }
            checklist.push({desc: 'Micro Inverters', count: tg_qty+se_qty})
            if(this.state.accontroller && typeof this.state.accontroller !== "undefined" && this.state.accontroller.item_id > 0){
                lines.push(`1 x ${this.state.accontroller.manufacturer} ${this.state.accontroller.item_code} AC Controller/ Charger`)
                lineitems.push({desc: `${this.state.accontroller.manufacturer} ${this.state.accontroller.item_code} AC Controller/ Charger`, qty: 1, price: this.state.accontroller.item_cost,item_id: this.state.accontroller.item_id})
                checklist.push({desc: 'AC Charger / Controller', count: 1})
            }
        }else {
            if(this.state.accontroller && typeof this.state.accontroller !== "undefined" && this.state.accontroller.item_id > 0){
                lines.push(`1 x ${this.state.accontroller.manufacturer} ${this.state.accontroller.item_code} AC Controller/ Charger`)
                lineitems.push({desc: `${this.state.accontroller.manufacturer} ${this.state.accontroller.item_code} AC Controller/ Charger`, qty: 1, price: this.state.accontroller.item_cost,item_id: this.state.accontroller.item_id})
                checklist.push({desc: 'AC Charger / Controller', count: 1})

                // Add AC Charger extra Install & Electrical Eqipment costs.
                const acextra = ancillarycosts.find(item => (item.ac_id == 1000 && item.code =='accharger-battery-install') )
                if(acextra ) {
                    lineitems.push({desc: `${acextra.description}`, qty: 1, price: acextra.item_cost,item_id: acextra.item_id})
                    checklist.push({desc: 'AC Charger Ancillaries & Install', count: 1}) 
                }
            }


        }
        // Now add the following items. But Exclude Sofar Warrantys as we want these at the end
        const anclength = ancillarycosts.length;
        for(let il=0; il<anclength; il++) {
            let docalc = true
            
            const item = ancillarycosts[il]
            // Check for # of sides of scaff
            if(item.code =="scafps") {
                if(item.fieldvar > "" ) {
                    let found = this. state.ancillary_items.find((x) => x.key == item.fieldvar) 
                    let qty = 0
                    if(found) 
                        qty = Number(found.value)
                    if(!found && typeof this.state[item.fieldvar] !== "undefined") 
                        qty = Number(this.state[item.fieldvar])

                    if(typeof qty == "undefined" || qty== "" || isNaN(qty)) qty = 0

                    scaff_sides+=qty
                }
            }
            if(item.fieldvar > "" && !item.warranty && item.lovingreturns) {
                let found = this.state.ancillary_items.find((x) => x.key == item.fieldvar)
                let qty = 0
                if(found)  qty = Number(found.value)
                if(!found && typeof this.state[item.fieldvar] !== "undefined") 
                        qty = Number(this.state[item.fieldvar])
                if(typeof qty == "undefined" || qty== "" || isNaN(qty)) qty = 0
                if(qty > 0) lines.push(`${item.description} x ${qty}`)
                
            }

        }

        
        if(this.state.vo) {
            lines.push("1 x Voltage Optimiser")
            const voextra = ancillarycosts.find(item => (item.ac_id == 1400 && item.code =='voltage-optimiser') )
            let vo_price = 650
            if(voextra) vo_price = voextra.item_cost
            lineitems.push({desc: 'Voltage Optimiser', qty: 1, price: vo_price, ac_id: 1400})
        }
        checklist.push({desc: 'VO', count:this.state.vo?1:0 })
        
        if(this.state.has_iboost) {
            lines.push("1 x Solar iBoost")
            const ibextra = ancillarycosts.find(item => (item.ac_id == 1500 && item.code =='solar-iboost') )
            let ibs_price = 600
            if(ibextra) ibs_price = ibextra.item_cost
            lineitems.push({desc: 'iBoost', qty: 1, price: ibs_price, ac_id: 1500})
        }
        checklist.push({desc: 'iBoost', count:this.state.has_iboost?1:0 })
        
        if(this.state.has_smart_thermostat)
           lines.push("1 x Smart Thermostat")
        //console_log(this.state.evcharger)
        if( typeof this.state.evcharger !== "undefined" && 
            this.state.evcharger.description !== "No EV Charger Required") {
            lines.push("EV Charger " + this.state.evcharger.description)
            lineitems.push({desc: `EV Charger ${this.state.evcharger.description}`, qty: 1, price: this.state.evcharger.customer_price, evid: this.state.evcharger.uid})           
            checklist.push({desc: 'EV Charger', count: 1 })
            if(this.state.batteryonly) {
                const evextra = ancillarycosts.find(item => (item.ac_id=1100 && item.code =='evcharger-battery-install'))
                if(evextra) {
                    lineitems.push({desc: 'Battery Only Install with EV Charger', qty: 1, price: evextra.item_cost, ac_id: evextra.ac_id})           
                    checklist.push({desc: 'Battery Only with EV Charger', count: 1 })                   
                }
            }
        }
        else 
            checklist.push({desc: 'EV Charger', count: 0 })
   
        if(this.state.batteryonly == false) {
            if( birdprotection_cnt > 0 )
                lines.push("Bird Protection for " + birdprotection_cnt + " Panels")

                lines.push("All fixings/cabling/meter/Isolators/Ancillaries")
        }
        lines.push("18th Edition IET wiring regs RCD & surge protection if required")
        lines.push("2 years Workmanship Warranty")

        var inv_warranty = "5 Year Inverter Warranty"
        if(typeof required_inverters !== "undefined" && required_inverters.length > 0 && typeof required_inverters[0].inverter.manufacturer !== "undefined") {
            switch(required_inverters[0].inverter.manufacturer.toUpperCase()) {
                case "ATON" :
                    inv_warranty = "10 Year Aton Inverter Warranty"
                    break;
                case "SOFAR" :
                    inv_warranty = "5 Year Sofar Inverter Warranty"
                    break;
                case "GROWATT" :
                    inv_warranty = "10 Year Growatt Inverter Warranty"
                    break;
                case "SOLAREDGE" :
                        inv_warranty = "12 Year Solaredge Inverter Warranty"
                        break;
                case "GIVENERGY" :
                    inv_warranty = "5 Year Givenergy Inverter Warranty"
                    break;
                case "SOLAX" :
                    inv_warranty = "10 Year Solax Inverter Warranty"
                    break;
                case "HUAWEI" :
                    inv_warranty = "10 Year Huawei Inverter Warranty"
                    break;
                case "FOX" :
                    inv_warranty = "5 Year Fox Inverter Warranty +5 year online upgrade to 10"
                    break;
            }
        }




            if(batfound && batfound.battery_id !== 1 && batfound.description !== "No Battery") {
                let bat_warranty = `${batfound.warranty} Year ${this.titleCase(batfound.manufacturer)} Battery Warranty `
                if(batfound.warranty_note > "")
                    bat_warranty += " - " + batfound.warranty_note
                lines.push(bat_warranty);
                lineitems.push({desc: bat_warranty, qty: 1, price: 0, battwarranty: 0})
            }
        }
        var pan_warranty = "25 Year Panel Performance Warranty"
        switch(this.state.offerid ) {
            case '7 Day Offer 1':
                pan_warranty = "30 Year Panel Performance Warranty"
                break;
            case '7 Day Offer 2':
                inv_warranty =  "20 Year Inverter Warranty"         
                break;
        }
        if(this.state.batteryonly == false) {
            lines.push(inv_warranty)
            const anclength = ancillarycosts.length;
            for(let il=0; il<anclength; il++) {
                let process = true
                const item = ancillarycosts[il]
                if(this.state.batteryonly && item.battery_only == false ) 
                    process=false

                if(item.fieldvar > "" && item.warranty && item.lovingreturns && process ) {
                    let found = this.state.ancillary_items.find((x) => x.key == item.fieldvar)
                    let qty = 0
                    if(found) 
                        qty = Number(found.value)

                    if(!found && typeof this.state[item.fieldvar] !== "undefined") 
                            qty = Number(this.state[item.fieldvar])
                    
                    if(typeof qty == "undefined" || qty== "" || isNaN(qty)) qty = 0
                    if(qty > 0)  lines.push(`${item.description} x ${qty}`)
                }
            }
        }
        if(this.state.batteryonly == false)
            lines.push(pan_warranty)
/*******************************/
        lines.push("HIES 10 year maximum consumer protection")
        if(this.state.batteryonly == false)
            lines.push("EPVS validation certificate")
        lines.push("MCS certification")
        if(this.state.batteryonly == false)
            lines.push("Pre-Installation Survey")
        if(this.state.batteryonly == false)
            lines.push("Full installation including all access equipment")
        else 
            lines.push("Battery installation to connect to existing systems")
        
        // lines.push(`Access Equipment Cost £ ${scaff_sides * pdf_config.scaff_perside}`)

        if(this.state.limiterRequired > 0 && this.state.batteryonly == false)
            checklist.push({desc: 'Limiter Required', count: this.state.limiterRequired})
        this.setState({line_items: lines, birdprotection_cnt})

    }

    // Generate parts list with quantities and OpenSolarCodes (no prices)
    generatePartsList = () => {
        const partsList = []
        // Note: ancillarycosts is the module-level catalogue populated in componentDidMount
        // (APIAncillaryCosts). It used to be destructured from this.state here too, which
        // shadowed the module-level one with `undefined` — pushMountingPart's
        // `ancillarycosts.find(...)` then threw.
        const { panels, inverters, batterys } = this.state
        const panelArrays = this.props.panelArrays
        const required_inverters = this.props.required_inverters
        const battery = this.props.battery

        // Add Panels
        if (panelArrays && panelArrays.length > 0) {
            let panelGroups = {}
            panelArrays.forEach(panelArray => {
                const panel_id = panelArray.panel_id
                const numPanels = parseInt(panelArray.numPanels) || 0
                if (panelGroups[panel_id]) {
                    panelGroups[panel_id].qty += numPanels
                } else {
                    const panel = panels?.find(p => p.panel_id === panel_id)
                    panelGroups[panel_id] = {
                        desc: panel ? `${panel.manufacturer} ${panel.description} ${panel.watts}W` : panelArray.panelModel,
                        qty: numPanels,
                        openSolarCode: panel?.OpenSolarCode || ''
                    }
                }
            })
            Object.values(panelGroups).forEach(item => {
                if (item.qty > 0) partsList.push(item)
            })
        }

        // Add Inverters
        if (required_inverters && required_inverters.length > 0) {
            let inverterGroups = {}
            required_inverters.forEach(inv => {
                if (inv.inverter && inv.inverter.id >= 0 && inv.inverter.id !== -2) {
                    const inv_id = inv.inverter.id
                    const desc = `${inv.inverter.manufacturer} ${inv.inverter.itemcode} ${inv.inverter.watts}W`
                    if (inverterGroups[inv_id]) {
                        inverterGroups[inv_id].qty += 1
                    } else {
                        const inverter = inverters?.find(i => i.id === inv_id)
                        inverterGroups[inv_id] = {
                            desc: desc,
                            qty: 1,
                            openSolarCode: inverter?.OpenSolarCode || ''
                        }
                    }
                }
            })
            Object.values(inverterGroups).forEach(item => partsList.push(item))
        }

        // Add Battery
        if (battery && battery.battery_id && battery.battery_id !== 1) {
            const bat = batterys?.find(b => b.battery_id === battery.battery_id)
            partsList.push({
                desc: `${battery.manufacturer} ${battery.description} ${battery.watts}kWh`,
                qty: 1,
                openSolarCode: bat?.OpenSolarCode || ''
            })
        }

        // Add Rails, Hooks, Clamps, End Stops — quantities derived from layoutSets,
        // SKUs resolved through mounting_hardware_map by per-array railColour.
        const railsHooksTotals = this.calculateRailsHooksTotals(panelArrays)
        const findSlotForParts = (section, slot_type, installation_id) => {
            return (mountingHardwareMap || []).find(s =>
                s.section === section &&
                (slot_type === undefined || s.slot_type === slot_type) &&
                (installation_id === undefined || s.installation_id === installation_id)
            )
        }
        const pushMountingPart = (slot, qty) => {
            if (!qty || qty <= 0) return
            if (!slot || slot.ac_id == null) return
            const anc = (ancillarycosts || []).find(a => a.ac_id === slot.ac_id)
            if (!anc) return
            partsList.push({
                desc: anc.description,
                qty,
                openSolarCode: anc.OpenSolarCode || ''
            })
        }
        ;['silver', 'black'].forEach(colour => {
            const c = (railsHooksTotals.byColour && railsHooksTotals.byColour[colour]) || {}
            pushMountingPart(findSlotForParts(colour, 'rail'),     c.rails)
            pushMountingPart(findSlotForParts(colour, 'clamp'),    c.clamps)
            pushMountingPart(findSlotForParts(colour, 'end_stop'), c.endStops)
            pushMountingPart(findSlotForParts(colour, 'splice'),   c.splice)
        })
        Object.entries(railsHooksTotals.hooksByInstallation || {}).forEach(([installIdStr, qty]) => {
            const installation_id = parseInt(installIdStr)
            pushMountingPart(findSlotForParts('hook', 'hook',         installation_id), qty)
            pushMountingPart(findSlotForParts('hook', 'flashing_kit', installation_id), qty)
            pushMountingPart(findSlotForParts('hook', 'hook_stop',    installation_id), qty)
        })

        // Add Ancillary items (that have been selected by user)
        if (this.state.ancillary_items && this.state.ancillary_items.length > 0) {
            this.state.ancillary_items.forEach(item => {
                const qty = parseInt(item.value) || 0
                if (qty > 0) {
                    const ancillary = ancillarycosts?.find(a => a.fieldvar === item.key)
                    if (ancillary) {
                        partsList.push({
                            desc: ancillary.description,
                            qty: qty,
                            openSolarCode: ancillary.OpenSolarCode || ''
                        })
                    }
                }
            })
        }

        return partsList
    }

    processPDFPages = async () => {
        if(this.state.flg_id === "undefined")
            return
        if(pdf_pages === null)
            return

        // TWe know what work needs to be done to each page from our pdf_field_mappings.js config
        //this.updateParent()
        //this.createLineItems()

        // Mail Merge Slides that need merging
        const num_slides = pdf_pages && pdf_pages.getNumPages() ? pdf_pages.getNumPages() : 61
        for(var i=1; i<=num_slides; i++) {
            const page = pdf_pages.getOnePage(i)            
            if(pdf_pages.isMailMerge(i)) {
                if(pdf_pages.hasFilter(i) ) {
                    if( pdf_pages.getFilter(i) === this.state.offerid.substr(0,pdf_pages.getFilter(i).length) ) {
                        await this.processMergePage(i)
                    }
                }else {
                    await this.processMergePage(i)
                }
            }
            else if(pdf_pages.isCreateDataTables(i)) {
                await this.processDatatables(i)
            }   
            else if(pdf_pages.isMergeImages(i))   
                await this.MergeImages(i, this.state.filelist)        
        }
  
        this.setState({ merge_completed: true, show_agreement: false, calculating: false})
    }

    MergeImages = async (slide_id) => {
        const flg_id = this.state.flg_id
        console_log("MergeImages")
        console_log(this.state.filelist)
        if(this.state.create_documents)
            await APIImageMerge(flg_id,slide_id, this.state.filelist)
        return 
    }
    
    updateParent = async () => {

        const {financeterm, financeoption, savings, selected_maintenance,systemcost,slides,filelist, offerid, required_inverters,
                net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount,
                extra_order_info, presentation_versions, selected_presentation, ancillary_items, finance_charge, hold_base_price, sweep_sale
        } = this.state

        this.props.onChange({financeterm, financeoption, savings, selected_maintenance,systemcost,slides,filelist, offerid, required_inverters,
                net_cost,selfgen,vat,commperc,comm_sacrifice,additional_discount,delivery_miles,create_documents,dont_update_base,shared_discount, 
                extra_order_info, presentation_versions, selected_presentation, ancillary_items, finance_charge, hold_base_price, sweep_sale
        })
        const utime = Date.now()
        this.setState({force_pdf_reload: utime })
    }
    processMergePage = async(page) => {
        // See code in PDFMerge.js
        let st = {...this.state, // And add any REDUX Data we want to push in with it.
            conservation_area: this.props.conservation_area,
            listed_property: this.props.listed_property,
            propertytype: this.props.propertytype,
            customer2name: this.props.customer2name,
            customer2surname: this.props.customer2surname,
            customer2title: this.props.customer2title,
            deposit_amount: this.props.deposit_amount,
            panelArrays: this.props.panelArrays,
            elecrate: this.props.elecrate,
            fin_totalcost: this.props.fin_totalcost,
            fin_monthlypayment: this.props.fin_monthlypayment,
            mpan: this.props.mpan_number,
            noratedisclaimer: this.props.noratedisclaimer,
            propertytype: this.props.propertytype,
            offgrid_system: this.props.offgrid_system
            
        }

        if(this.state.create_documents)
            await PDFMergePage(page, JSON.parse(JSON.stringify(st)))
    }


    processDatatables = async (page) => {
        if(this.state.create_documents) {
            const pdf_page = pdf_pages.getOnePage(page).page    // Output page
            const panelFixings = this.summaryPanelFixings(this.props.panelArrays)
            let st = {...this.state, // And add any REDUX Data we want to push in with it.
                conservation_area: this.props.conservation_area,
                listed_property: this.props.listed_property,
                propertytype: this.props.propertytype,
                customer2name: this.props.customer2name,
                customer2surname: this.props.customer2surname,
                customer2title: this.props.customer2title,
                deposit_amount: this.props.deposit_amount,
                panelArrays: this.props.panelArrays,
                elecrate: this.props.elecrate,
                fin_totalcost: this.props.fin_totalcost,
                fin_monthlypayment: this.props.fin_monthlypayment,
                mpan: this.props.mpan_number,
                noratedisclaimer: this.props.noratedisclaimer,
                propertytype: this.props.propertytype,
                panelFixings,
                offgrid_system: this.props.offgrid_system
            }
            //st.panelArrays = this.props.panelArrays
            const agreementdata = await PDFProcessDataTables(page, JSON.parse(JSON.stringify(st)), pdf_page, ancillarycosts, batterys, this.state.filelist )
            this.props.updateagreementdata({agreementdata, pricing_out: this.state.pricing_out})
            this.setState({show_agreement: true, calculations_run: true, calculating: false})
        }
    }

    // Tab has changed so uSwitch between detail and summary view
    handleTabChange = (event, value) => {
        this.setState({selectedTab: value})
    }

    handleSaleType = (event) => {
        var offerid = '7 Day Offer 5'
        const saletype = event.target.value
        if(saletype === this.state.saletype) return
        // Get the default Offer of for this Sale Type
        console_log("start offertype " + this.state.offerid )
        const offlength = json_offer.length;
        for(var i=0; i<offlength; i++)
            if(json_offer[i].type === saletype &&  json_offer[i].default)
                offerid = json_offer[i].offerid
                console_log("end offertype " + offerid )
                    
        this.setState({saletype, offerid}, () => { this.updateParent();}) 

    }
    
    handleOfferType = async (event) => {
        const offerid = event.target.value

        var sc = typeof this.state.systemcost??10000;
        if(sc <= 0) sc = 10000

        const net_cost = this.getOfferSystemCost(offerid, sc)
        let sellprice = this.getSellPrice()
        
        
        this.setState({offerid, sellprice, systemcost: sc}, () => { this.updateParent();}) 

    }
    
    handleCloseArrayDataDialog = () => {
        this.setState({merge_completed: false, show_agreement: true})
    }
    
    handleAdditionsChange = name => event => {
        if(name =='dont_update_base' && !this.state.admin) return
        if(name =='dont_update_base') 
            this.setState({ dont_update_base: event.target.checked, hold_base_price: this.state.systemcost },() => this.updateParent() );
        else        
            this.setState({ [name]: event.target.checked });
    };


    handleAncillaryCostItem = name => event => {
        console_log(`handleAncillaryCostItem ${name} ${event.target.value}`)
        let field_val = event.target.value
        let ac = ancillarycosts.find(x => x.fieldvar == name)
        if(typeof ac !== "undefined" && ac) {
            if(event.target.value > ac.input_field_max)
                field_val = ac.input_field_max
        }
        // Build a new array (don't mutate state in place, or Redux/PureComponent
        // consumers won't see the change).
        const prev = this.state.ancillary_items || []
        const existing = prev.find(x => x.key == name)
        const ai = existing
            ? prev.map(x => x.key == name ? { ...x, value: field_val } : x)
            : [...prev, { key: name, value: field_val }]
        this.setState({ ancillary_items: ai }, () => { this.updateParent() });
    }

    onSlideChange = async (slides, presentation_versions, selected_presentation ) => {
        console_log("**** onSlideChange in => CalcResults")
        console_log(presentation_versions)
        this.setState({slides, presentation_versions, selected_presentation}, () => { this.updateParent();})
    }

    onUploadChange = async  (filelist) => {
        this.setState({filelist}, () => { this.updateParent();})
    }

// Sleep for x milliseconds - must be called with await from an Async Function
sleep = async (x) => {
        return new Promise( resolve => setTimeout(resolve, x));
}

closeCalcsRun = () => { this.setState({show_calculations_run: false })}

// Send the Agreement for Signing using Adobe Sign.
sendAgreement = async () => {
    let payload = {
        flg_id:                         this.state.flg_id,
        site_id:                        this.props.selected_site??0,
        customer2email:                 this.props.customer2email,              
        customer2name:                  this.props.customer2name,
        email:                          this.state.email,
        full_name:                      this.props.full_name,
        customer_message_top:           this.state.customer_message_top,
        customer_message_rep:           this.props.customer_message_rep,
        customer_message_footer:        this.state.customer_message_footer,
        rep_email:                      this.state.rep_email,
        rep_name:                       this.state.rep_name,
        postcode:                       this.state.postcode,
        savedquote_data:                this.props.agreementdata,
        state:                          JSON.stringify(this.state)
    }

    this.setState({calculating: true})
    let ret = await APIAddAgreementVersion(payload)
    // let ret = await APIAddAgreementVersionForSite(payload)
    let severity = 'error'
    let msg = ''
    if(typeof ret !== "undefined" && ret && ret.status ) {
        severity = 'success'
        msg = `${ret.message} and Sent.  Reference: ${this.state.flg_id}/${ret.version} (Version - ${ret.version} of the Agreement)`         
    }else
        msg = `An Error occured Sending the Agreement! ${ret.message}`

    this.setState({calculating: false, show_adobe: true, adobe_severity: severity, adobe_text: msg, agreement_version: ret.version})
}

handleSharedDiscount = e => {
    const prev_shared_discount = this.state.shared_discount
    const shared_discount = e.target.value
    
    if(prev_shared_discount == shared_discount)
        return
    let comm_sacrifice =0
    /*if(shared_discount >= 1000)
        comm_sacrifice = shared_discount / 2;
    else */
    //if(shared_discount <= 400 )
        comm_sacrifice= shared_discount / 2;
    //else 
    //    comm_sacrifice = shared_discount-200;
    
    this.setState({comm_sacrifice, shared_discount}, () => { this.updateParent();})
    
}

updateCustomerMsg = e => {

    this.props.updaterepcustomermsg(e.target.value)
}

updateDBFromRedux = e => {
    this.props.updatesaveredux()
}

updateBirdProtectConfirmed = e => {
    this.props.birdprotectionconfirmed(e.target.checked)
}

updateRateDisclaimer = e => {
    this.props.updatenoratedisclaimer(e.target.checked)
}

updateAgreementChecked = e => {
    this.props.agreementcheckconfirmed(e.target.checked)
}

updateOffGridSystem = e => {
    this.props.updateoffgridsystem(e.target.checked)
}

handleMonthlyPayment = event => {
   this.props.updatefinmonthlypayment(event.target.value??0.00)
};

// Monthly paymenys x Term must be >= Total Amount Payable
checkMonthlyAmount = () => {
    if(parseInt(this.props.fin_monthlypayment * ((this.state.selectedFinanceTerm+1)*12)) < parseInt(this.props.fin_totalcost))
        return true
    return false
}

handleTotalCostWithFinance = event => {
    this.props.updatefintotalcost(event.target.value??0.00)
 };

// Check that the Total Amount With Credit is >=0 or >=  Customer price. Return true (Error) if not otehrwsie fale (Ok) 
checkTotalCostIsValid = () => {
    let fin_total_cost = parseFloat((this.props.fin_totalcost??0))
    let deposit_amount = parseFloat((this.props.fin_totalcost??0))
    // console.log(`${deposit_amount} ${fin_total_cost} ${Number((fin_total_cost??0)+Number(deposit_amount))} < ${Number(this.state.net_cost??10000)}`)
    if( this.props.fin_totalcost <= 0.00 || Number((fin_total_cost + deposit_amount )) < Number(this.state.net_cost??10000) )
        return true
    return false
 }

getPaymentMethod = () => { 
    if(typeof this.state == "undefined" || typeof this.state.financeoption == "undefined" || this.state.financeoption==null || typeof this.state.financeoption.description == "undefined")
        return 
    let paymentmethod = this.state.financeoption.description??"Cash"
    if( paymentmethod!= "Cash")
        paymentmethod="Finance"
    return paymentmethod;
 }
 getGraphData = () => {
    const ifrom = 0
    const  ito = pdf_config.years_per_page-1
    const data = this.state.savings
    let outdata = []
    console.log(data)
    for(let il=ifrom; il<=ito; il++) {
        if(data && data[il] && data[il].electric_cost)
            outdata.push({x:il, y:parseInt(data[il].electric_cost), y2: parseInt(parseFloat(data[il].electric_cost)- parseFloat(data[il].accumulative_savings)) })
        else
            outdata.push({x: il, y:0,y2:0})
            //outdata.push({x:il, y: il*2, y2: il})

    }
    console.log(outdata)
    return outdata
 }
 
    render() {
        const { classes } = this.props;
        let open = this.state.calculating;
        let net_cost = this.state.net_cost
        const {saletype,currency, offertype, offerid,vat, required_inverters, additional_discount }= this.state
        const has_finance = this.state.selectedFinance > 0 ? true : false
        const detail_tab = this.state.calcterm + ' Year Detail Table'
        let commperc = this.state.commperc
        if(this.state.sweep_sale) commperc = 0

        let baseprice = this.state.systemcost??10000.00 
        if(this.state.dont_update_base && (this.state.hold_base_price??0) >0) 
            baseprice = this.state.hold_base_price
        let sellprice = this.getSellPrice()

        sellprice = (sellprice??0).toFixed(2)
        if(sellprice <= 0) {
            sellprice = this.getSellPrice()
            sellprice = (sellprice??0).toFixed(2)
        }
        const selected_financeoption = (this.state.financeoption??true) && this.state.financeoption ? this.state.financeoption.uid : 0
        let selected_mo = this.state.selected_maintenance ? this.state.selected_maintenance.maintenance_id : 0
        selected_mo = isNaN(selected_mo) ? 0 : selected_mo
        //console.log(`selected_mo = ${selected_mo}`)
        //console.log(this.state.maintenanceoptions)
        const fltr_offers = this.state.offers.filter(item => {return item.type === saletype})

        let commission = ( (net_cost - this.state.additional_discount ) * (commperc / 100)) 
        this.outputPricing(commission)
        let inverter_manufacturer = '';
        if( (required_inverters??false) && required_inverters.length > 0) {
            if((required_inverters[0].inverter??true) && (required_inverters[0].inverter.manufacturer??true))
                inverter_manufacturer = required_inverters[0].inverter.manufacturer
        }
        // Make sure the Send PDF Order form can be Enabled
        let sendpdf = false            
        if(this.props.agreement_confirmsend)
            if(this.state.birdprotection_cnt > 0)
                sendpdf = true
            else if(this.props.birdprotection_confirmsend)
                sendpdf = true
        let dno = 'Unknown DNO'
        if(!this.ValidateMPAN(this.props.mpan_number)) {
            if(!this.props.offgrid_system)
                sendpdf=false   // Only need MPAN and DNO if on grid system.
        } else {
            let tmpan = this.props.mpan_number??""
            if(tmpan > "" ){
                let fnd = pdf_config.dnos.find(fld => fld.id == tmpan.substring(0,2))
                if( fnd) dno = fnd.network
            }
        }
        const manager = []
        manager.push(this.state.manager)
            
        if(inverter_manufacturer != "SOFAR" && this.state.sofarWarrantyUpgrade > 0 )
            this.setState({sofarWarrantyUpgrade: 0})
        let create_documents = this.state.create_documents
        if(create_documents > 0 ) create_documents = true
        else if(create_documents == 0) create_documents = false

        const paymentmethod=this.getPaymentMethod()
        // Dont Allow Agreement to be Sent if Finance Options not set.
        if(paymentmethod !== "Cash") {
            if(this.props.fin_monthlypayment <= 0 || this.checkTotalCostIsValid() || this.checkMonthlyAmount())
                sendpdf = false
        }
        const agreement_version = this.state.agreement_version??1+''
        //let graphData = this.getGraphData()
        return(
            <div style={{width: '100%', height: '100%', textAlign: 'center'}} >
                     <Backdrop className={classes.backdrop} open={open} >
                        <CircularProgress color="inherit" size={100}/>
                    </Backdrop>
            <ErrorDialog title={this.state.errTitle} text={this.state.errText}  open={(this.state.errOpen==true && this.state.errTitle > "" & this.state.errText > "") ? true: false} onClose={this.handleErrDaialogClose} />
            <Alerts3 
                open={this.state.merge_completed} state={this.state} onClose={this.handleCloseArrayDataDialog }
            />
            <TableContainer  className={classes.tabletop} >
                <Table  size="small" aria-label="a dense table">
                    <TableBody>
                        <TableRow>
                        <TableCell style={{borderBottom: 0}} >
                            {(this.state.financeOptions??false) && this.state.financeOptions.length>0 && 
                            <SelectItems name="financeOptions" title="Select Payment Option"   frmClass={classes.margin}  ctlClass={classes.financeOptions} 
                                value={selected_financeoption}     onChange={this.handleFinanceOptions}      
                                data={this.state.financeOptions}   dataKey="uid"  dataVal="uid"  dataDesc="description"   mnuClass={classes.SelectItems}  /> 
                            }
                            {(selected_financeoption > 0 ) && 
                              <SelectItems name="financeTerm"   title="Term"  frmClass={classes.financeTerm}    ctlClass={classes.financeTerm} 
                                value={this.state.selectedFinanceTerm}  
                                onChange={this.handleFinanceTerm}   
                                data={financeTerms}   dataKey="uid"  dataVal="uid"  dataDesc="description"   mnuClass={classes.financeTerm}  />
                            }
                            
                            {(this.state.maintenanceoptions??false) && this.state.maintenanceoptions.length >0 && 
                                <SelectItems name="maintenanceOptions"   title="Maintenance Option"  frmClass={classes.maintenanceOption}    ctlClass={classes.maintenanceOption} 
                                value={selected_mo}  onChange={this.handleMaintenanceOptions}   
                                data={this.state.maintenanceoptions}   dataKey="maintenance_id"  dataVal="maintenance_id"  dataDesc="description"   mnuClass={classes.SelectItems}  /> 
                            }
                            <SelectItems name="listedProperty"   title="Listed Building"  frmClass={classes.listedProperty}    ctlClass={classes.listedProperty} 
                            value={this.props.listed_property}  onChange={this.handleListedProperty}   
                            data={ [{value: "", description: 'Select'},{value: "Yes",description: 'Yes'},{value: "No", description: 'No'}]}   
                            dataKey="value"  dataVal="value"  dataDesc="description"   mnuClass={classes.SelectItems}  error=""/> 

                            <SelectItems name="conservationArea"   title="Conservation Area"  frmClass={classes.conservationArea}    ctlClass={classes.conservationArea} 
                            value={this.props.conservation_area}  onChange={this.handleConservationArea}   
                            data={ [{value: "", description: 'Select'},{value: "Yes",description: 'Yes'},{value: "No", description: 'No'}]}   
                            dataKey="value"  dataVal="value"  dataDesc="description"   mnuClass={classes.SelectItems} error="" />                             
                        {paymentmethod != "Cash" &&
                        <><br/>
                                <FormControl className={classes.financeOptions} >
                                    <InputLabel id="lblFinMonthlyPayment">Monthly Payment Amount</InputLabel>
                                    <Input labelid="lblFinMonthlyPayment" 
                                            style={{fontSize: 12, width: '12ch'}}
                                            value={this.props.fin_monthlypayment } 
                                            onChange={this.handleMonthlyPayment}
                                            error={this.props.fin_monthlypayment<=0 || this.checkMonthlyAmount() ? true : false}
                                            startAdornment={<InputAdornment position="start" >{this.state.currency}</InputAdornment>} />
                                </FormControl>
                                <FormControl className={classes.financeOptions} style={{width: 280}} >
                                    <InputLabel id="lblFinMaximumPayment" >Total Maximum Cost with Finance</InputLabel>
                                    <Input labelid="lblFinMaximumPayment" 
                                            style={{fontSize: 12, width: '14ch'}}
                                            value={this.props.fin_totalcost}
                                            onChange={this.handleTotalCostWithFinance}
                                            error={this.checkTotalCostIsValid()}
                                            startAdornment={<InputAdornment position="start" >{this.state.currency}</InputAdornment>} />
                                </FormControl></>}    
                            
                            
                        </TableCell>
                        <TableCell rowSpan={2} style={{borderBottom: 0}}>
                                <img src={logo} alt='MT Solar' className={classes.logo} width="150" /><br/>
                                <ColorButton variant="contained" color="primary" onClick={this.APICalcSavings}
                                    disabled={this.props.listed_property == "" || this.props.conservation_area=="" ? true : false}
                                >Calculate Savings</ColorButton><br/>
                                {this.state.admin && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={this.handleDownloadJobSheet}
                                        sx={{ fontSize: 11, mb: 1 }}
                                    >
                                        Download Job Sheet (CSV)
                                    </Button>
                                )}
                                <FormControlLabel
                                    checked={true}
                                    value={true}
                                    control={<Checkbox  size="small" checked={!!create_documents} onChange={this.handleAdditionsChange('create_documents')} />}
                                    label={<Typography  style={{fontSize: 12}} >Create Documents</Typography>}
                                    labelPlacement="end"
                                />
                                {this.props.listed_property=="" && <Typography  style={{fontSize: 10, color: 'red'}} >Select if Property is Listed</Typography> }
                                {this.props.conservation_area=="" && <Typography  style={{fontSize: 10, color: 'red'}} >Select if in Conservation Area</Typography> }
                                
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2} style={{borderBottom: 0}} >
                            <SelectItems name="saletype"   title="Sale Type"  frmClass={classes.saletype}    ctlClass={classes.saletype} 
                                value={saletype}  onChange={this.handleSaleType}   
                                data={[{type: 'FIELD'},{type: 'PHONE'}]}   dataKey="type"  dataVal="type"  dataDesc="type"   mnuClass={classes.mnuoffertype}  /> 
                            <SelectItems name="offertype"   title="Offer"  frmClass={classes.offertype}    ctlClass={classes.offertype} 
                                value={offerid}  onChange={this.handleOfferType}   readOnly={!this.state.admin }
                                data={fltr_offers}   dataKey="offerid"  dataVal="offerid"  dataDesc="text"   mnuClass={classes.mnuoffertype}  />                             

                                <FormControl className={classes.margin} >
                                    <InputLabel id="lblSystemCost">Base Price</InputLabel>
                                    <Input labelid="lblSystemCost" 
                                            style={{fontSize: 12}}
                                            value={baseprice.toString() } 
                                            onChange={this.handleSystemCost} 
                                            startAdornment={<InputAdornment position="start" >{this.state.currency}</InputAdornment>} />
                                </FormControl>
                                <FormControl className={classes.margin} >
                                    <InputLabel id="lblSystemCost2">Net Cost</InputLabel>
                                    <Input labelid="lblSystemCost2" 
                                            style={{fontSize: 12}}
                                            value={(net_cost??0).toFixed(2)} 
                                            readOnly
                                            startAdornment={<InputAdornment position="start" >{this.state.currency}</InputAdornment>} />
                                </FormControl>
                                <FormControl className={classes.margin} >
                                    <InputLabel id="lblSystemCost3">Customer Price</InputLabel>
                                    <Input labelid="lblSystemCost3" 
                                            style={{fontSize: 12}}
                                            value={sellprice} 
                                            readOnly
                                            startAdornment={<InputAdornment position="start" >{this.state.currency}</InputAdornment>} />
                                </FormControl>
                                <FormControl  className={classes.margin} >
                                <InputLabel id="lbl-deposit-amount">Deposit</InputLabel>
                                    <Input
                                        labelid="lbl-deposit-amount"
                                        error={this.props.deposit_amount<=0}
                                        style={{fontSize: 12}}
                                        id="deposit-amount"
                                        value={this.props.deposit_amount}
                                        onChange={this.handleDeposit} 
                                        startAdornment={<InputAdornment position="start">&pound;</InputAdornment>}
                                    />
                                </FormControl>
                                <SelectItems name="saletype"   title="Property Type"  frmClass={classes.propertytype}    ctlClass={classes.propertytype} 
                                value={this.props.propertytype??'Residential'}  onChange={this.handlePropertyType}   
                                data={[{type: 'Residential'},{type: 'Commercial'}]}   dataKey="type"  dataVal="type"  dataDesc="type"   mnuClass={classes.mnupropertytypetype}  />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <AppBar position="static">
                <Tabs value={this.state.selectedTab} onChange={this.handleTabChange}  aria-label="simple tabs example" style={{background: '#6fcae7'}}>
                    <Tab label="Summary" {...a11yProps(0)} />
                    <Tab label={detail_tab} {...a11yProps(1)} />
                    <Tab label="Slides" {...a11yProps(2)} />
                    <Tab label="Upload Pictures" {...a11yProps(3)} />
                    <Tab label="Order Info" {...a11yProps(4)} />
                    <Tab label="Price" {...a11yProps(5)} />
                    <Tab label="Parts List" {...a11yProps(6)} />
                    <Tab label="Versions" {...a11yProps(7)} />
                    <Tab label="Agreement" {...a11yProps(8)} />
                    <Tab label="Presenter" {...a11yProps(9)} />
                    { 1==2 && <Tab label="Graph" {...a11yProps(10)} />}
                </Tabs>
            </AppBar>
            <TabPanel key={0} value={this.state.selectedTab} index={0} >
                        <CalcResultsSummaryTables  state={this.state} />
            </TabPanel>
            <TabPanel key={1} value={this.state.selectedTab} index={1} >
                {!this.state.calculations_run && 
                <Alert severity="info">You must Run Calculations before you can view the Details Slide</Alert>                        
                }
                {this.state.calculations_run && <CalcResultsDetailsTables state={this.state} /> }
            </TabPanel>
            <TabPanel key={2} value={this.state.selectedTab} index={2} >
                <SlideSetup 
                saletype={this.state.saletype} 
                offertype={offertype} 
                offerid={offerid} 
                flg_id={this.state.flg_id} 
                key={this.state.saletype}
                slides={this.state.slides} 
                calculations_run={this.state.calculations_run}
                presentation_versions={this.state.presentation_versions}
                selected_presentation={this.state.selected_presentation}
                onChange={this.onSlideChange}
                />
            </TabPanel>
            <TabPanel key={3} value={this.state.selectedTab} index={3} >
                <PictureUploads filelist={this.state.filelist} flg_id={this.state.flg_id} onChange={this.onUploadChange} />
            </TabPanel>
            <TabPanel key={4} value={this.state.selectedTab} index={4} >
                <Typography>Add Extra Order Information below (Max 70 Chars x 12 Lines)</Typography>
                <TextField
                    multiline
                    fullWidth={true}
                    rows={12}
                    rowsMax={12}
                    value={this.state.extra_order_info}
                    onChange={this.handleAdditionOrderinfo}
                />
            </TabPanel>            
            <TabPanel key={5} value={this.state.selectedTab} index={5} >
                  <Collapse in={this.state.show_alert}> 
                    <Alert
                      variant='outlined'
                      style={{width: '800px', alignItems: 'center', textAlign: 'top', marginTop: '10px'}} 
                      severity={this.state.alert_severity}          
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            this.setState({show_alert: false})
                          }}
                        >
                        <CloseIcon fontSize="inherit" />
                        </IconButton > } >
                          {this.state.alert_text}
                    </Alert>
                  </Collapse>   
            <TableContainer  className={classes.pricetabletop} >
                <Table   size="small" classes={{root: classes.customTable}}  aria-label="a dense table">
                    <TableBody>
                        <TableRow>
                            <TableCell variant="body" style={{verticalAlign: 'top'}} >
                                <Table   size="small" classes={{root: classes.customTableCheckList}}  aria-label="a dense table">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={2} className={classes.checklistheading} >Check List Summary</TableCell>
                                        </TableRow>
                                        {checklist && checklist.map((item, index)=>{ 
                                        return (<TableRow key={index}>
                                                <TableCell style={{lineHeight: 1, fontSize: '12px'}} >{item.desc}</TableCell>
                                                <TableCell style={{lineHeight: 1, fontSize: '12px'}} >{item.count}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableCell>
                            <TableCell variant="body" style={{verticalAlign: 'top'}} >
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={2}  className={classes.priceheading} style={{color: "darkgreen"}} >WOS Phone Sales Model</TableCell>
                                        </TableRow><TableRow>
                                            <TableCell style={{borderBottom: 0}}>Nett Cost</TableCell>
                                            <TableCell style={{borderBottom: 0, textAlign: 'right'}}><NF value={net_cost } cur={currency} /></TableCell>
                                        </TableRow><TableRow>
                                            <TableCell style={{borderBottom: 0}}>VAT @ {vat}%</TableCell>
                                            <TableCell style={{borderBottom: 0, textAlign: 'right'}}><NF value={net_cost * (vat/100)} cur={currency} /></TableCell>
                                        </TableRow><TableRow>
                                            <TableCell style={{borderBottom: 0}}>Total Cost (Phone Discount)</TableCell>
                                            <TableCell style={{borderBottom: 0, textAlign: 'right'}}><NF value={net_cost * (1+ (vat/100))} cur={currency} /></TableCell>
                                        </TableRow>
<TableRow>
                                            <TableCell >Offer Discount</TableCell>
                                            <TableCell style={{textAlign: 'right'}}><NF value={additional_discount} cur={currency} /></TableCell>
                                        </TableRow><TableRow> 
                                            <TableCell >WOS/Rep Shared Discount</TableCell>
                                            <TableCell  style={{textAlign: 'right'}}><NF value={this.state.shared_discount} cur={currency} /></TableCell>
                                        </TableRow><TableRow>
                                            <TableCell style={{fontWeight: '900'}} >Customer Price</TableCell>
                                            <TableCell style={{fontWeight: '900',textAlign: 'right'}} ><NF value={sellprice} cur={currency} /></TableCell>
                                        </TableRow><TableRow>
                                            <TableCell  style={{borderBottom: 0}}>System Base Price</TableCell>
                                            <TableCell  style={{borderBottom: 0,textAlign: 'right'}}><NF value={this.state.systemcost} cur={currency} /></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableCell>
                            <TableCell  variant="body" style={{verticalAlign: 'top'}} >
                                <Table size="small" >
                                    <TableBody>
                                        <TableRow>
                                            <TableCell className={classes.checklistheading}  colSpan={2} >Commissions</TableCell>
                                        </TableRow>
                                        {this.state.manager && 
                                            <TableRow>
                                                <TableCell style={{borderBottom: 0}}>Sweep Sale</TableCell>
                                                <TableCell style={{borderBottom: 0,textAlign: 'right'}}><Checkbox checked={this.state.sweep_sale??false} onChange={this.handleSweepSale}/></TableCell>
                                            </TableRow> 
                                        } 
                                        {this.state.manager && this.state.sweep_sale &&
                                            <>                                            
                                            <TableRow>
                                                <TableCell style={{borderBottom: 0}}>Rep: {this.props.assigned_rep} - Commision</TableCell>
                                                <TableCell style={{borderBottom: 0,textAlign: 'right'}}>&pound;&nbsp;{pdfc.rep_sweep_commission}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{borderBottom: 0}}>Your Commision</TableCell>
                                                <TableCell style={{borderBottom: 0,textAlign: 'right'}}>&pound;&nbsp;{pdfc.manager_sweep_commission}</TableCell>
                                            </TableRow>
                                            </>
                                        }
                                        {this.state.sweep_sale && 
                                        <>
                                            <TableCell className={classes.checklistheading}  colSpan={2} >** Sale has been Swept **</TableCell>
                                        </>
                                        }
                                        <TableRow>
                                            <TableCell style={{borderBottom: 0}}>Enter Commission %</TableCell>
                                            <TableCell style={{borderBottom: 0,textAlign: 'right'}}><Input style={{fontSize: 12}} value={(commperc??'').toString()} onChange={this.handleComsPerc}
                                            endAdornment={<InputAdornment position="end" >%</InputAdornment>} disableUnderline readOnly={this.state.sweep_sale} disabled={this.state.sweep_sale}  /></TableCell>
                                        </TableRow><TableRow>
                                            <TableCell style={{borderBottom: 0}}>Commission</TableCell>
                                            <TableCell style={{borderBottom: 0,textAlign: 'right'}}><NF value={commission}  cur={currency}  /></TableCell>
                                        </TableRow><TableRow>                                        
                                            <TableCell style={{borderBottom: 0}}>Self Gen</TableCell>
                                            <TableCell style={{borderBottom: 0,textAlign: 'right'}}><Checkbox disabled={this.state.sweep_sale}  checked={this.state.selfgen ? true  : false} onChange={this.handleSelGen} /></TableCell>
                                        </TableRow><TableRow>                                        
                                            <TableCell style={{borderBottom: 0}}>Comm Sacrifice</TableCell>
                                            <TableCell style={{borderBottom: 0,textAlign: 'right'}}><NF value={this.state.comm_sacrifice} cur={currency} /></TableCell>
                                        </TableRow>
                                        <TableRow>                                        
                                            <TableCell style={{borderBottom: 0}}>WOS Fixed Cost<br/>Comms Deduction</TableCell>
                                            <TableCell style={{borderBottom: 0,textAlign: 'right'}}><NF value={commperc * cfg('wos_fixed_deduction_per_pct', 7)} cur={currency} /></TableCell>
                                        </TableRow>
                                        <TableRow>                                        
                                            <TableCell style={{borderBottom: 0}}>Total Commission</TableCell>
                                            <TableCell style={{borderBottom: 0,textAlign: 'right'}}><NF value={((commission??0)  + (this.state.selfgen ? cfg('selfgen_bonus', 300) : 0) - (this.state.comm_sacrifice??0)) - ((commperc??0) * cfg('wos_fixed_deduction_per_pct', 7)) } cur={currency} /></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Table stickyHeader aria-label="sticky table" sx={{ maxHeight: 200 }} size="small" classes={{root: classes.customTable}} >
                    <TableHead>
                        <TableRow>
                            <TableCell>Item</TableCell>
                            <TableCell>Qty</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.batteryonly == false &&
                        <TableRow>
                            <TableCell>Shared Discount</TableCell>
                            <TableCell>
                                <Select disableUnderline
                                    labelid="commDiscountShared"
                                    value={this.state.shared_discount}
                                    onChange={this.handleSharedDiscount}
                                    className={classes.sharedCommsSelect} >
                                    <MenuItem key={0} value={0}>No Additional Discount</MenuItem>
                                    <MenuItem key={1} value={100}>£100 - Shared £50 WOS / £50 Rep</MenuItem>
                                    <MenuItem key={2} value={200}>£200 - Shared £100 WOS / £100 Rep</MenuItem>
                                    <MenuItem key={3} value={300}>£300 - Shared £150 WOS / £150 Rep</MenuItem>
                                    <MenuItem key={4} value={400}>£400 - Shared £200 WOS / £200 Rep</MenuItem> 
                                    <MenuItem key={5} value={500}>£500 - Shared £250 WOS / £250 Rep</MenuItem> 
                                    <MenuItem key={6} value={600}>£600 - Shared £300 WOS / £300 Rep</MenuItem> 
                                    <MenuItem key={7} value={700}>£700 - Shared £350 WOS / £350 Rep</MenuItem> 
                                    <MenuItem key={8} value={800}>£800 - Shared £400 WOS / £400 Rep</MenuItem> 
                                    <MenuItem key={9} value={900}>£900 - Shared £450 WOS / £400 Rep</MenuItem> 
                                    <MenuItem key={10} value={1000}>£1000 - Shared £500 WOS / £500 Rep</MenuItem> 
                                </Select>                            
                            </TableCell>
                        </TableRow>}
                        <TableRow>
                            <TableCell>Delivery Miles</TableCell>
                            <TableCell><Input style={{borderBottom: 0,fontSize: 14}} value={this.state.delivery_miles??''.toString()}  onChange={this.handleDeliveryMiles}  disableUnderline  inputProps={{step: 1,min: 0,max: 1000, type: 'number'}} sx={{ m: 1, width: "10ch" }}/>
                            <Button c={classes.deliveryMilesBtn} onClick={() => {this.handleGetDeliveryMiles()}} >Calc Miles</Button>
                            </TableCell>
                        </TableRow>
                        {typeof ancillarycosts !== "undefined" && ancillarycosts.length > 0 && ancillarycosts.map((item,index) => {
                            // Dont Add SOFAR Inverter Warranrty if we dont have a SOFAR Inverter
                            let add_item = true
                            if(item.code == "sofar10wrnty") 
                                add_item = this.CheckInSOFARInverter(this.state.required_inverters)
                            
                            if(item.input_field && item.fieldvar > ""  && add_item) { 
                                let itemvalue = 0;
                                if(item.input_field_type == 'string') itemvalue = "";
                                if(typeof this.state.ancillary_items.find((x) => x.key == item.fieldvar) !== "undefined" )
                                itemvalue = this.state.ancillary_items.find((x) => x.key == item.fieldvar).value
                                return (
                                <TableRow key={`${item.fieldvar}_${index}`} >
                                    <TableCell>{item.description}</TableCell>
                                    <TableCell><Input id={item.fieldvar} style={{borderBottom: 0,fontSize: 14}} value={itemvalue}  onChange={this.handleAncillaryCostItem(item.fieldvar)} disableUnderline  inputProps={{step: 1, min: item.input_field_min ,max: item.input_field_max ,type: item.input_field_type}} sx={{ m: 1, width: "10ch" }} /></TableCell>
                                </TableRow>
                            )}
                            })}
                        {lineitems && lineitems.map((item,index) => { if(typeof(item.skip) == "undefined" || ( (typeof(item.skip) !== "undefined" && item.skip==false)) ) 
                        return (<TableRow key={index} >
                        <TableCell >{item.desc}</TableCell>
                            <TableCell >{(item.qty??0)}</TableCell>
                        </TableRow>)})
                        }
                        <TableRow><TableCell colSpan={2} style={{borderBottom: 0, height: "400px"}} ></TableCell></TableRow>
                        <TableRow><TableCell colSpan={2} style={{borderBottom: 0}} >
                            <FormControlLabel
                                readOnly={this.state.admin }
                                checked={true}
                                value={true}
                                control={<Checkbox  size="small" checked={this.state.dont_update_base ? true : false} onChange={this.handleAdditionsChange('dont_update_base')} />}
                                label={<Typography  style={{fontSize: 12}} >Don't Update Base Prices</Typography>}
                                labelPlacement="end"
                            />                        
                        </TableCell></TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            </TabPanel>
            <TabPanel key={6} value={this.state.selectedTab} index={6} >
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>Description</strong></TableCell>
                                <TableCell><strong>Quantity</strong></TableCell>
                                <TableCell><strong>OpenSolar Code</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.generatePartsList().map((part, index) => (
                                <TableRow key={index}>
                                    <TableCell>{part.desc}</TableCell>
                                    <TableCell>{part.qty}</TableCell>
                                    <TableCell>{part.openSolarCode || '-'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </TabPanel>
            <TabPanel key={7} value={this.state.selectedTab} index={7} >
                <PresenterVersions
                    presentation_versions={this.state.presentation_versions} 
                    flg_id={this.props.flg_id}
                />
            </TabPanel>
            <TabPanel key={8} value={this.state.selectedTab} index={8} >
            <Table stickyHeader aria-label="sticky table" sx={{ maxHeight: 200 }} size="small" classes={{root: classes.customTable}} >
                    <TableBody>
                        <TableRow><TableCell>Customer 2 Details (If Required)</TableCell></TableRow>
                        <TableRow><TableCell>
                        <Input 
                            value={this.props.customer2title}
                            id="customer2title"
                            disableUnderline={true}
                            placeholder = "Title"
                            sx={{width: '15ch'}}
                            onChange={this.updateCustomer2Title}
                            onBlur={this.updateDBFromRedux}
                            />
                        <Input 
                            value={this.props.customer2name}
                            id="customer2name"
                            disableUnderline={true}
                            placeholder = "Name"
                            sx={{width: '20ch'}}
                            onChange={this.updateCustomer2Name}
                            onBlur={this.updateDBFromRedux}
                            />
                        <Input 
                            value={this.props.customer2surname}
                            id="customer2surname"
                            disableUnderline={true}
                            placeholder = "Surname"
                            sx={{width: '40ch'}}
                            onChange={this.updateCustomer2Surname}
                            onBlur={this.updateDBFromRedux}
                            />
                       <Input 
                            value={this.props.customer2email}
                            id="customer2email"
                            disableUnderline={true}
                            placeholder = "Email"
                            sx={{width: '100ch'}}
                            onChange={this.updateCustomer2Email}
                            onBlur={this.updateDBFromRedux}
                            />
                        </TableCell></TableRow>
                        <TableRow><TableCell style={{borderBottom: 0}}>Message To Customer:</TableCell></TableRow>
                        <TableRow><TableCell style={{borderBottom: 0}}>{ReactHtmlParser(this.state.customer_message_top.replace('[--VERSION--]', agreement_version))}</TableCell></TableRow>
                        <TableRow><TableCell style={{borderBottom: 0}}>
                            <Input
                                multiline
                                disableUnderline={true}
                                id="msg_ccustomisation"
                                fullWidth={true}
                                rows={4}
                                rowsMax={4}
                                value={this.props.customer_message_rep}
                                onChange={this.updateCustomerMsg}
                                onBlur={this.updateDBFromRedux}
                                placeholder = "Place any additional message text you want here. This message will dissaper when you start typing, and will not show up in the customers message."
                            />
                        </TableCell></TableRow>
                        <TableRow style={{borderBottom: 0}}><TableCell>{ReactHtmlParser(this.state.customer_message_footer)}</TableCell></TableRow>
                        <TableRow style={{borderBottom: 0, marginTop: 20}} >
                            <TableCell style={{borderBottom: 0}}>
                            <FormControlLabel                                
                                    checked={true}
                                    value={true}
                                    control={<Checkbox  size="small" checked={!!this.props.offgrid_system} onChange={this.updateOffGridSystem} />}
                                    label={<Typography  style={{fontSize: 12}} >Off Grid System.</Typography>}
                                    labelPlacement="end"
                                /> 
                                <FormControl  className={classes.financeOptions} >
                                    <InputLabel id="lbl-mpan">Customer MPAN Number</InputLabel>
                                        <Input
                                            labelid="lbl-mpan"
                                            error={!this.ValidateMPAN(this.props.mpan_number)}
                                            style={{fontSize: 12}}
                                            id="mpan-number"
                                            value={this.props.mpan_number}
                                            onChange={this.handleMPAN} 
                                        />
                                </FormControl>
                                <FormControl className={classes.dnoClass} >
                                    <InputLabel id="lbl-dno">DNO</InputLabel>
                                        <Input
                                            labelid="lbl-dno"
                                            style={{fontSize: 12}}
                                            id="mpan-number"
                                            value={dno}
                                            readOnly={true}
                                        />
                                </FormControl>
                            </TableCell>
                        </TableRow>
                        <TableRow style={{borderBottom: 0, marginTop: 20}} >
                            <TableCell>
                                <FormControlLabel
                                    checked={true}
                                    value={true}
                                    control={<Checkbox  size="small" checked={!!this.props.agreement_confirmsend} onChange={this.updateAgreementChecked} />}
                                    label={<Typography  style={{fontSize: 12}} >Click to confirm you have checked the Agreement.</Typography>}
                                    labelPlacement="end"
                                />     
                                {this.state.birdprotection_cnt <= 0 && <br/> &&
                                    <FormControlLabel
                                    checked={true}
                                    value={true}
                                    control={<Checkbox  size="small" checked={!!this.props.birdprotection_confirmsend} onChange={this.updateBirdProtectConfirmed} />}
                                    label={<Typography  style={{fontSize: 12}} >Click to confirm you have discussed Bird Protection with the customer.</Typography>}
                                    labelPlacement="end"
                                />
                                }                   
                                <FormControlLabel
                                    checked={!!this.props.noratedisclaimer}
                                    value={true}
                                    control={<Checkbox  size="small" checked={!!this.props.noratedisclaimer} onChange={this.updateRateDisclaimer} />}
                                    label={<Typography  style={{fontSize: 12}} >Click to confirm a Rate Disclaimer is NOT Required.</Typography>}
                                    labelPlacement="end"
                                /> 
                                <ColorButton variant="contained" color="primary"disabled={!sendpdf} className={classes.sendAgreementBtn} onClick={() => {this.sendAgreement()} } >Send Agreement</ColorButton>
                                {this.props.deposit_amount <=0 && <Typography style={{color: '#ff1010', fontSize: 12}} >NB: No Deposit set.</Typography>}
                                {!this.props.offgrid_system  && !this.ValidateMPAN(this.props.mpan_number) && <Typography style={{color: '#ff1010', fontSize: 12}} >A Valid MPAN Number is Required to send the Agreement</Typography>}      
                                {paymentmethod !== "Cash" && this.props.fin_monthlypayment <=0 && <Typography style={{color: '#ff1010', fontSize: 12}} >Finance Monthly Amount MUST to be set</Typography>}
                                {paymentmethod !== "Cash" && this.props.fin_totalcost <=0 && <Typography style={{color: '#ff1010', fontSize: 12}} >Total Cost with Finance MUST be set.</Typography>}
                                {paymentmethod  !== "Cash" && this.checkTotalCostIsValid() && <Typography style={{color: '#ff1010', fontSize: 12}} >Total Cost with Finance MUST be &gt;= Customer Price.</Typography>}        
                                {paymentmethod  !== "Cash" && this.checkMonthlyAmount()  && <Typography style={{color: '#ff1010', fontSize: 12}} >Monthly Payments x Payment Term MUST be = Total Cost with Finance.</Typography>}  
                                <Collapse in={this.state.show_adobe}> 
                                    <Alert
                                        variant='outlined'
                                        style={{width: '800px', alignItems: 'center', textAlign: 'top', marginTop: '10px'}} 
                                        severity={this.state.adobe_severity}          
                                        action={
                                            <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                this.setState({show_adobe: false})
                                            }}
                                        >
                                        <CloseIcon fontSize="inherit" />
                                        </IconButton > } >
                                        {this.state.adobe_text}
                                    </Alert>
                                </Collapse> 
                            </TableCell>                            
                        </TableRow>

                    </TableBody>
                </Table>
                <br/>
                {this.state.show_agreement &&
                <OrderAgreement presentation_versions={this.state.presentation_versions} 
                    flg_id={this.props.flg_id} key={this.state.force_pdf_reload} force_reload={this.state.force_pdf_reload}
                /> }
            </TabPanel>
            <TabPanel key={9} value={this.state.selectedTab} index={9} >
            <Table stickyHeader aria-label="sticky table"  size="small" classes={{root: classes.customTable}} >
                <TableBody>
                    <TableRow>
                        <TableCell style={{borderBottom: 0}}>
                            <PresentationViewer presentation_versions={this.state.presentation_versions} flg_id={this.props.flg_id} />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            </TabPanel>
            {1 ==2 && <TabPanel key={10} value={this.state.selectedTab} index={10} >
                <div style={{width: '800px', textAligh: 'center', alignContent: 'center'}} >
                {(this.state.savings && this.state.savings[0] && this.state.savings[0].electric_cost) && <>
                <Typography>Graph of Energy with & without solar</Typography>
                <div className="header"><span style={{color: 'red'}}>Energy Costs Without Solar</span><br/>
                <span style={{color: '#00ff00'}}>Energy Costs With Solar</span><br/>
                </div>
                {/* <LineChart data={graphData} /> */}
                </>
                }
                {(!this.state.savings || !this.state.savings[0] || !this.state.savings[0].electric_cost) &&
                    <>
                    <Typography>You Must Calculate Savings first</Typography>    
                    </>   
                }
                </div>
            </TabPanel> }
            </div>
        )
    }
}

const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: 'white',
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
    },
    
    customTable: {
      paddingTop:  2,
      paddingLeft: 2,
      paddingBottom: 2,
      paddingRight: 2
    },
    customTableCheckList: {
      paddingTop:  0,
      paddingLeft: 2,
      paddingBottom: 0,
      paddingRight: 2,
      fontSize: '14px'
        
    },
    selected: {
        backgroundColor: '#90EEA4',
      },
    paper: {
 
    },
    spacerRow: {
        height: 2,
        borderLeft: 0,
        borderRight: 0,
        border: 0,
    },
    table: {
        lineHeight: 0.5,
        marginLeft: '5px',
        marginRight: '5px'
    },
    priceheading: {
        fontSize: '20px',
        fontWeight: 'bold',
        textAlign: 'center',
        borderBottom: 0
    },
    checklistheading: {
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center',
        borderBottom: 0
    },
    container2_table: {
        width: '100%',
        alignItems: 'center',
        paddingLeft: '1px',
        paddingRight: '1px',
        borderWidth: 0,
        boxShadow: 'none',
 
    },
    checklistitems: {
      borderBottom: '1px solid black'  
    },
    tabletop: {
        lineHeight: 0.2,
        border: '0px solid white'
    },
    pricetabletop: {
        lineHeight: 0.2,
        border: '0px solid white',
        width: '1280px',
        maxwidth: '1540px',
        overflowX : 'auto'
    },
    table2: {
        height: 500,
        border: '0px solid white'
    },
    bigfont: {
        fontSize: '24px',
        fontWeight: 'bold'
    },
    yrheadersaving: {
        backgroundColor: '#ff3099',
        color: 'white', 
        fontWeight: '900',
        textAlign: 'center',
        fontSize: '16px',
        borderLeft: '1px solid black',
        borderRight: '1px solid black'

    },
    headerwkwph: {
        width: 100,
    },
    headermoney: {
        width: 100,
    },
    totalRows: {
        fontWeight: 800,
        color: 'black',
    },
    yr1headers: {
 
    },
    borderRow: {
        border: '2px solid #326cd8',
    },
    header30: {
        backgroundColor: '#04c659',
        color: 'white',  
    },
    style30years: {
        fontSize: 14,
        fontWeight: 800,
        textDecoration: 'underline',
        paddingTop: 10,
        paddingBottom: 10,
        border: 0,
    },
    savingsHeaders: {
        backgroundColor: '#04c659',
        color: 'white',
        width: 100,
        fontWeight: 800,
        paddingTop: 2,
        paddingBottom: 2,
    },
    input: {
        fontSize: 12,
        paddingLeft: 5,
    },
    text30: {
        fontSize: 14,
        paddingTop: 2,
        paddingBottom: 2,

    },
    text30_beakeven: {
        fontSize: 14,
        paddingTop: 2,
        paddingBottom: 2,
        backgroundColor: '#90EEA4',

    },
    text_small: {
        fontSize: 12,
        paddingTop: 3,
        paddingBottom: 3,
    },
    yr1pt1: {
      color: '#326cd8',
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'center'
    },
    yr1pt2: {
      color: '#ff3099',
      fontSize: '28px',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    yr1pt3: {
      color: '#326cd8',
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'center'
    },
    mediumFont: {
      color: '#326cd8',
      fontSize: '22px',
      fontWeight: 900,
      textAlign: 'center'
        
    },
    topRows: {
        paddingTop: 2,
        paddingBottom: 2,
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: '16px'
    },
    financeOptions: {
        fontSize: 12,
        width: 240,
    },
    dnoClass:{
        fontSize: 12,
        width: 300,
    },
    lblFinanceOptions: {
        width: 240,
    },
    SelectItems: {
        fontSize: 12,
    },
    costinput: {
        paddingBottom: 0,
        fontSize: 12,
    },
    margin: {
        margin: theme.spacing(1),
        paddingBottom: 0,
    },
    financeTerm: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 120,    
        fontSize: 12
    },
    listedProperty: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 120,    
        fontSize: 10
    },
    conservationArea: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 140,    
        fontSize: 10
    },


    maintenanceOption: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 200,    
        fontSize: 12
        
    },
    saletype: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 100,    
        fontSize: 12      
    },
    propertytype: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 150,    
        fontSize: 12 
    },
    offertype: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 200,    
        fontSize: 12   
    },
    mnuoffertype: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 200,    
        fontSize: 12   
    },
    mnupropertytype: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 150,    
        fontSize: 12   
    },
    wosButton: {
        borderWidth: 1,
        backgroundColor: '#ffffff',
        fontSize: 12,
        paddingTop: 5,
        paddingBottom:5
    
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    sharedCommsSelect: {
        fontSize: 12,
    },
    deliveryMilesBtn: {
        fontSize: 12,
    },
    sendAgreementBtn: {
        fonrSize: 12,
    }
});

const mapStateToProps = (state) => {
    return {
        // === NEW SLICE DATA (single source of truth) ===
        // Energy slice
        elecrate: selectElecRate(state),
        elecconsumption: selectElecConsumption(state),
        selected_tariff: selectSelectedTariff(state),
        selfconsumption: selectSelfConsumption(state),
        gasconsumption: selectGasConsumption(state),
        gasrate: selectGasRate(state),
        gas_estimated: selectGasEstimated(state),

        // Addons slice
        vo: selectVoltageOptimiser(state),
        has_iboost: selectIBoost(state),
        has_smart_thermostat: selectSmartThermostat(state),
        has_boiler_manager: selectBoilerManager(state),
        evcharger: selectEVCharger(state),
        softGround: selectSoftGround(state),
        hardGround: selectHardGround(state),
        delivery_miles: selectDeliveryMiles(state),

        // System slice
        battery: selectBattery(state),
        panelArrays: selectPanelArrays(state),
        savings: selectSavings(state),
        required_inverters: selectRequiredInverters(state),
        is3phase: selectIs3Phase(state),
        offgrid: selectOffgrid(state),
        accontroller: selectACController(state),
        batteryonly: selectBatteryOnly(state),

        // Financial slice
        systemcost: selectSystemCost(state),
        net_cost: selectNetCost(state),
        vat: selectVat(state),
        hold_base_price: selectHoldBasePrice(state),
        financeoption: selectFinanceOption(state),
        financeterm: selectFinanceTerm(state),
        finance_charge: selectFinanceCharge(state),
        commperc: selectCommPerc(state),
        comm_sacrifice: selectCommSacrifice(state),
        additional_discount: selectAdditionalDiscount(state),
        shared_discount: selectSharedDiscount(state),
        selected_maintenance: selectSelectedMaintenance(state),
        ancillary_items: selectAncillaryItems(state),
        offerid: selectOfferId(state),
        dont_update_base: selectDontUpdateBase(state),

        // Customer slice
        flg_id: selectFlgId(state),
        full_name: selectCustomerName(state),
        first_name: selectCustomerFirstName(state),
        email: selectCustomerEmail(state),
        address: selectFullAddress(state),
        postcode: selectPostcode(state),
        rep_name: selectRepName(state),
        rep_email: selectRepEmail(state),
        sweep_sale: selectSweepSale(state),
        assigned_rep: selectAssignedRep(state),
        extra_order_info: selectExtraOrderInfo(state),
        selfgen: selectSelfGen(state),

        // === LEGACY REDUCERS (still needed for agreement/forms) ===
        electric_estimated: state.electric_estimated,
        listed_property: state.listed_property,
        conservation_area: state.conservation_area,
        deposit_amount: state.deposit_amount,
        customer_message_rep: state.customer_message_rep,
        save_redux: state.save_redux,
        customer2email: state.customer2email,
        customer2name: state.customer2name,
        customer2surname: state.customer2surname,
        customer2title: state.customer2title,
        agreement_confirmsend: state.agreement_confirmsend,
        birdprotection_confirmsend: state.birdprotection_confirmsend,
        fin_monthlypayment: state.fin_monthlypayment,
        fin_totalcost: state.fin_totalcost,
        agreementdata: state.agreementdata,
        mpan_number: state.mpan_number,
        noratedisclaimer: state.noratedisclaimer,
        propertytype: state.propertytype,
        offgrid_system: state.offgrid_system,
        selected_site: state.selected_site
    };
};  

const mapDispatchToProps = {
    updatelistedproperty,
    updateconservationarea,
    updatedeposit,
    updaterepcustomermsg,
    updatesaveredux,
    updatecustomer2name,
    updatecustomer2surname,
    updatecustomer2title,
    updatecustomer2email,
    agreementcheckconfirmed,
    birdprotectionconfirmed,
    updatefintotalcost,
    updatefinmonthlypayment,
    updateagreementdata,
    updatempan,
    updatenoratedisclaimer,
    updateoffgridsystem,
    updatepropertytype,
    updateselectedsite,
    // Addons slice — parent's syncStateToRedux skips these after initial load,
    // so Price-tab handlers dispatch them directly to keep Redux in sync.
    setDeliveryMiles,
    setSoftGround,
    setHardGround
}
export default withStyles(styles, { withTheme: true })(connect( 
    mapStateToProps,
    mapDispatchToProps
)(CalcResults));